import moment from "moment";
import { LoanStage } from "@toorak/tc-common-fe-sdk";
import { LoanStatusEnum, LoanTypeEnum } from "@toorak/tc-common-util-sdk";
import { ObjectType } from "../../masterView/common";
// import { UPDATE_TTF_FIELDS } from "../../stores/documentReview/DocumentReview.action";
import {
  getLoanInfoForTTF,
  getPropertyInfoForTTF,
  patchLoanData,
  removeLoanEscrowMap,
  removePropertyEscrowMap
} from "../../network/apiService";
import {
  evaluateLoan,
  getCalulatedDatafromRules,
  getOverriddenOutputValues,
  getOverriddenOutputs,
  getRuleEvaluationByLoanId,
  postOverrideOutput,
  updateOverriddenInredux
} from "../../stores/EvaluationResults/EvaluationResults.action";
// import { clearLoader } from "../../stores/loaderAndException/loaderAndException.action";
import {
  loanCreditFields,
  loanInformationFields,
  propertyInformationFields,
  unitInformationFields
} from "../../stores/loanAndPropertyDetails/helpers/loanAndPropertyFields";
import {
  getSectionObjectForRedux,
  updateLoanDetailsInRedux,
  updatePropertyDetailsInRedux
} from "../../stores/loanAndPropertyDetails/loanAndPropertyDetails.action";
import { getAffectedWaivers } from "../../stores/WaiverRequest/WaiverRequest.action";
import {
  formatCurrencyValue,
  formatValueByType,
  isEmptyValue
} from "../../utils/formatChecks";
import {
  fieldsTobeCalculatedOnInitialLoad,
  hasPath,
  isCreditBureau,
  isCreditEventField,
  isValuationField,
  resolvePath,
  resolveSmartPath,
  resolveValuationPath
} from "../../utils/utils";
import {
  condoEligibilityDropDown,
  condoEligibilityV2DropDown,
  LoanStructureTypes,
  rentDescription,
  ToorakProductEnum
} from "../constants/loanCreationDropDownValues";
import {
  calculateMonthDifference,
  formatResponse,
  getLoanHistory,
  // GET_LOAN_BY_ID_SUCCESS,
  // GET_PROPERTY_DETAILS,
  postLoan,
  postPropertyData,
  prepareLoanSummaryObj,
  // POST_LOAN_SUCCESS,
  prepareObjectForTemplateMapping
} from "../create-loan.action";
import {
  getPropertyDetails,
  postLoanSuccess,
  setLoanByIdSuccess
} from "../create-loan.reducer";
import { LoanDetails } from "../create-loan.reducerHelper";
import {
  formatLoanDetailsResponse,
  formatPropertyResponse
} from "../CreateLoan";
import { getBridgeLoanGuarantorInformationToPass } from "../CreateLoanHeader";
import { getEvaluationRequestBody } from "../evaluation-results/helpers/ruleRequestBody";
import { getDropDownData } from "../property-details/30-year-loan-property-details/PropertyDetailsUnitInformation";
import {
  formatData,
  getFormattedAddress,
  typeCast
} from "../tape-to-file/TapeToFileUtils";
import {
  BRIDGE_REQUIRED_TAGS_FOR_TTFREVIEW,
  defaultComment,
  DOC_MAPPING_ENTITIES,
  docReviewActionTypeEnum,
  DSCR_REQUIRED_TAGS_FOR_TTFREVIEW,
  tabIds,
  tagGroups,
  ttfAction
} from "./constants";
import {
  snackBarOpenAndClose,
  snackBarOpenAndCloseReconcileView,
  somethingFailedMessage,
  submissionFailedMessage,
  submittedSuccessMessage,
  savedSuccessMessage
} from "./document-review/popup-messages/toastMessages";
import {
  BridgeLoanFields,
  DSCRLoanFields,
  BridgeUserFields,
  DSCRUserFields,
  DSCRPropertyFields,
  BridgePropertyFields,
  DSCRCalculatedFields,
  BridgeCalculatedFields,
  DSCRDataReconCalculatedFields,
  BridgeDataReconCalculatedFields,
  NewDataReconLoanFields,
  NewDataReconUserFields,
  NewDataReconPropertiesFields,
  ASFSheetLoanFields,
  ASFSheetUserFields,
  ASFSheetPropertiesFields,
  ASFSheetCalculatedFields
} from "./TTFFields";
import { AutomaticTaggedDocumentType } from "./types";
import { getLoanType } from "../../config/config";
import { clearLoader } from "../../stores/loaderAndException/loaderAndException.reducer";
import {
  updateCalculatedData,
  updateFieldSet,
  updateTtfFields
} from "../../stores/documentReview/DocumentReview.reducer";
import { postApprovalStates } from "../../utils/constants";
import { getBundleLoanData } from "../../stores/SettlementAndPurchase/SettlementAndPurchase.action";
import { setBundleLoanData } from "../../stores/SettlementAndPurchase/SettlementAndPurchase.reducer";
import { logger, LoggerLevel } from "../../utils/logger";
import { latestVersioningDate } from "../../v2/fields/LoanDetails/LoanInformation";
import {
  hideLoader,
  showLoader
} from "../../stores/loaderAndException/loaderAndException.action";
import { moveToReviewInProgress } from "../../utils/updateStatus";
import { cleanCurrency } from "../30-year-loan-details/ValidationRule";

const dateKeys = [
  { dateKey: "lastFcDate", monthsKey: "lastFcMonths" },
  { dateKey: "lastSsDate", monthsKey: "lastSsMonths" },
  { dateKey: "lastDilDate", monthsKey: "lastDilMonths" },
  { dateKey: "lastBkDate", monthsKey: "lastBkMonths" },
  { dateKey: "lastDelinquencyDate", monthsKey: "lastDelinquencyMonths" }
];

interface InputItem {
  value?: string;
  comment: string;
  updatedBy?: string;
  field: string;
}

const resolveLoanIdInPath = (path: string, loanId?: string) => {
  if (!path) return "";
  if (!path?.includes("[loanId]")) return path;
  return loanId ? path.replace("[loanId]", `${loanId}`) : path;
};

const getLoanFieldTprInfoPath = (path: string, loanId?: string) => {
  const resolvedPath = resolveLoanIdInPath(path, loanId);
  if (!resolvedPath) return "";
  if (resolvedPath.startsWith("loanResults.")) {
    return `data.${resolvedPath.replace("loanResults", "results")}`;
  }
  return `data.loans.${resolvedPath}`;
};

const getPropertyFieldTprInfoPath = (path: string, propertyIndex: number) => {
  if (!path) return "";
  if (path.startsWith("propertiesResults.")) {
    return `data.results.propertiesResults.${propertyIndex + 1}.${path.replace("propertiesResults.", "")}`;
  }
  return `data.properties.${propertyIndex}.${path}`;
};

const getCalculatedFieldTprInfoPath = (path: string, loanId?: string) => {
  const resolvedPath = resolveLoanIdInPath(path, loanId);
  if (!resolvedPath) return "";
  const finalPath = resolvedPath.startsWith("loanResults.")
    ? resolvedPath.replace("loanResults", "results")
    : resolvedPath;
  return `data.${finalPath}`;
};

export const prepareLoanFieldsForRedux = (
  loanDetails: LoanDetails,
  tagList: any[],
  isDSCR: boolean,
  baseData: any,
  dataPoints: any,
  key: string,
  editHistory: any,
  loanEvaluationResult: any,
  page: string,
  isDataReconSyncFlowEnabled?: boolean
) => {
  let fieldSet: any = isDSCR ? DSCRLoanFields : BridgeLoanFields;

  if (page === "reconcile") {
    fieldSet = [...fieldSet, ...NewDataReconLoanFields];
    fieldSet = removeDuplicateFields(fieldSet, ASFSheetLoanFields)
  }
  fieldSet = fieldSet.filter(
    (field: any) => !field.hidden || !field.hidden(loanDetails, page)
  );
  let loanFields: any[] = [];
  fieldSet.forEach((field: any) => {
    let obj: any = {};
    obj = prepareObj(
      obj,
      field,
      loanDetails,
      loanDetails?.loanInfo?.toorakProduct,
      editHistory,
      loanDetails?.loanDetailId?.created_on,
      loanDetails?.loanDetailId?.loanId,
      page
    );
    let { path } = field;
    obj.fieldFlattenedKey = `data.loans.${path}`;
    obj.tprInfoPath = getLoanFieldTprInfoPath(path, loanDetails?.loanDetailId?.loanId);
    if (path?.includes("loanResult")) {
      path = path.replace("[loanId]", `${loanDetails?.loanDetailId?.loanId}`);
      path = path.replace("loanResults", `results`);
      obj.fieldFlattenedKey = `data.${path}`;
      obj.tprInfoPath = `data.${path}`;
    }
    if (isDSCR && field.field === "currentLoanBalance") {
  const loanId = loanDetails?.loanDetailId?.loanId;

  if (loanId) {
    obj.auditPath = `result.loanResult.${obj.auditPath.replace("[loanId]", String(loanId))}`;
  }
}
    if (obj?.field === "armIndex" && obj?.loanInfo === "1 Month Term SOFR" && isDSCR) {
      obj.loanInfo = "30-day Average SOFR";
    }
    obj.isDSCR = isDSCR;
    loanFields.push(obj);
  });
  loanFields = loanFields?.map((item: any) => {
    if(item?.field === "totalOriginationAndDiscountPointsCurrency") {
      const parseCurrencyValue = (amount: any) => {
        if (amount === null || amount === undefined || amount === "") {
          return 0;
        }
        if (typeof amount === "number") {
          return Number.isFinite(amount) ? amount : 0;
        }
        return Number(cleanCurrency(String(amount))) || 0;
      }
      const loanOriginationFeeHUD = loanDetails?.loanFees?.originationFeeHUD
      const loanDiscountPointAmount = loanDetails?.loanDetailId?.discountPointAmount
      const hasLoanInfo = item?.loanInfo !== undefined && item?.loanInfo !== null && item?.loanInfo !== ""
      const hasLoanInfoDB = item?.loanInfoDB !== undefined && item?.loanInfoDB !== null && item?.loanInfoDB !== ""
      const loanInfoFallbackValue = parseCurrencyValue(loanOriginationFeeHUD) +
        parseCurrencyValue(loanDiscountPointAmount)
      return {
        ...item,
        loanInfo: !(hasLoanInfo || hasLoanInfoDB) ? formatData(loanInfoFallbackValue?.toString(), "currency") : item?.loanInfo,
        loanInfoDB: !(hasLoanInfo || hasLoanInfoDB) ? loanInfoFallbackValue : item?.loanInfoDB,
        ttfInfo: item?.ttfInfo,
        ttfInfoDB: item?.ttfInfoDB
      }
    } else {
      return { ...item }
    }
  })
  const userFields = prepareUserFieldsForRedux(
    loanDetails,
    loanDetails?.loanUserMap,
    isDSCR,
    editHistory,
    page,
    isDataReconSyncFlowEnabled
  );
  const { calculatedFields } = prepareCalculatedFieldsForRedux(
    loanEvaluationResult,
    isDSCR,
    baseData?.results
  );
  if (!Array.isArray(baseData)) {
    addLoanAndUserLevelBaseDataInfo(
      key,
      loanFields,
      userFields,
      baseData,
      page,
      false,
      loanDetails?.loanDetailId?.loanId,
      loanDetails
    );
  }
  loanFields.forEach((field: any, index: number) => {
    addMappings(field, index, dataPoints, "Loan", tagList);
  });
  userFields.forEach((field: any, index: number) => {
    addMappings(field, index, dataPoints, "User", tagList);
  });
  return {
    loanFields,
    userFields,
    calculatedFields
  };
};

export const preparePropertyFieldsForRedux = (
  propertyDetails: any = [],
  tagList: any[],
  leaseStatusDropdown: any,
  toorakProduct: string,
  isDSCR: boolean,
  baseData: any,
  dataPoints: any,
  key: string,
  editHistory: any,
  page: string,
  isDataReconSyncFlowEnabled?: boolean,
  loanDetails?: any
) => {
  let counter = 0;
  const sortedPropertyDetails = sortByKey(
    propertyDetails,
    "loanPropertyOrder",
    "loanPropertyId"
  );
  sortedPropertyDetails.forEach((property: any) => {
    if (property?.propertyUnit?.length > 1) {
      property.propertyUnit = sortByKey(
        property.propertyUnit,
        "propertyUnitOrder",
        "propertyUnitId"
      );
    }
    const findDeskReviewData = property?.valuations?.find(
        (item: any) => item?.appraisalType === "Desk Review"
      );
      if(!findDeskReviewData) {
        property.valuations = [
          ...property.valuations,
          {
            "valuationId": null,
            "valuationOrder": 100,
            "appraisalType": "Desk Review",
            "appraisalAsIsValue": null,
            "appraisalArvValue": null,
            "appraisalDate": null,
            "op": "add"
          }
        ]
      }
    if (property?.valuations?.length > 1) {
      property.valuations = sortByKey(
        property.valuations,
        "valuationOrder",
        "valuationId"
      );
    }
  });
  let fieldSet: any = isDSCR ? DSCRPropertyFields : BridgePropertyFields;
  if (page === "reconcile" && isDataReconSyncFlowEnabled) {
    fieldSet = [...fieldSet, ...NewDataReconPropertiesFields];
    fieldSet = removeDuplicateFields(fieldSet, ASFSheetPropertiesFields)
  }
  fieldSet = fieldSet.filter(
    (field: any) => !field.hidden || !field.hidden(propertyDetails, page)
  );
  const propertyFields: any[] = [];
  const escrowPropObj: any = [];
  sortedPropertyDetails.forEach((property: any, propertyIndex: number) => {
    const propertyUnit: any = [];
    escrowPropObj.push(property);
    fieldSet.forEach((element: any) => {
      if (
        element?.path === "valuations" &&
        (!property[element?.path] || property[element?.path].length === 0)
      ) {
        return; // skip to next field
      }
      const { key } = element;
      const propertiesResults =
        loanDetails?.loanResults?.propertiesResults?.[
          (propertyIndex ?? 0) + 1
        ] ?? {};
      let obj: any = {};
      if (key?.length && property[element?.path]?.length) {
        property[element?.path].forEach((unit: any, index: number) => {
          key.forEach((prop: string, index2: number) => {
            obj = {};
            obj.path =
              element?.path === "valuations"
                ? `${element?.path}.${unit.valuationOrder}.${prop}`
                : `${element?.path}.${index}.${prop}`;
            obj.tprInfoPath = getPropertyFieldTprInfoPath(obj.path, propertyIndex);
            obj.auditPath = `${
              element?.auditPath || element?.path
            }.${index}.${prop}`;
            obj.type = element?.type[index2];
            if (element?.values?.[index2] !== undefined) {
              obj.values = element?.values[index2];
              if (obj.values === "leaseStatusDropDown") {
                obj.values = leaseStatusDropdown;
              }
            }
            if (element?.aliasKey !== undefined) {
              obj.aliasKey = element?.aliasKey[index2];
            }
            if (element?.rulesKey !== undefined) {
              obj.rulesKey = element?.rulesKey[index2];
            }
            if (element?.skipRules !== undefined) {
              obj.skipRules = element?.skipRules[index2];
            }
            if (element?.disableAfterApproved !== undefined) {
              obj.disableAfterApproved = element?.disableAfterApproved[index2];
            }
            if (element?.outputDataMadeInput !== undefined) {
              obj.outputDataMadeInput = element?.outputDataMadeInput[index2];
            }
            if (element?.path === "valuations") {
              obj.extractedInfoPath = `${element?.path}.${prop}`;
              obj.fieldFlattenedKey = `data.properties.${propertyIndex}.${element?.path}.${index}.${element?.field[index2]}`;
              obj.auditPath = unit.valuationId
                ? element?.auditPath[index2].replace(
                    "valuationId",
                    unit.valuationId.toString()
                  )
                : element?.auditPath[index2].replace(
                    "valuationId",
                    `valuationOrder_${unit.valuationOrder.toString()}`
                  );
            }
            let valuationsLabel = `Appraised Value ${index + 1} ${element?.label[index2]}`
            if (unit?.appraisalType === "Desk Review") {
              const deskReviewLabels: any = {
                appraisalArvValue: "Desk Review ARV Value",
                appraisalAsIsValue: "Desk Review AS IS Value",
                appraisalDate: "Desk Review Valuation Date",
              };

              const fieldName = element?.field[index2];
              const customLabel = deskReviewLabels?.[fieldName];

              if (fieldName === "appraisalType") return;
              if (customLabel) valuationsLabel = customLabel;
            }
            obj.label =
              element?.path === "valuations"
                ? valuationsLabel
                : `Unit ${index + 1} ${element?.label[index2]}`;
            if (["Rent", "Amount"].includes(obj.label)) {
              obj.label += " ($)";
            } else if (obj.label.includes("Term")) {
              obj.label += " (Months)";
            }
            obj.loanInfoDB = unit[prop];
            obj.loanInfo = formatData(obj.loanInfoDB, obj.type);
            obj.documentInfo = "";
            obj.documentInfoDB = "";
            obj.categories = [];
            obj.documents = [];
            obj.field = element?.field[index2];
            obj.unitIndex = element?.path === "valuations" ? undefined : index;
            obj.propertyIndex = propertyIndex;
            obj.loanPropertyId = property.loanPropertyId;
            obj.loanPropertyOrder = property.loanPropertyOrder;
            obj.propertyUnitId = unit.propertyUnitId;
            obj.propertyUnitOrder = unit.propertyUnitOrder;
            obj.comment = defaultComment.updatedThroughTTF;
            obj.auditHistory = editHistory?.[getFieldName(obj)];
            obj.fieldFlattenedKey =
              obj.fieldFlattenedKey ??
              `data.properties.${propertyIndex}.${element?.path}`;
            obj.tprInfoPath = obj.tprInfoPath ?? getPropertyFieldTprInfoPath(obj.path, propertyIndex);
            if(unit?.op === "add") {
              obj.op = unit?.op
            }
            propertyUnit.push(obj);
          });
        });
      } else {
        obj.propertyIndex = propertyIndex;
        obj.loanPropertyId = property.loanPropertyId;
        obj.loanPropertyOrder = property.loanPropertyOrder;
        obj.fieldFlattenedKey = `data.properties.${propertyIndex}.${element?.path}`;
        obj.tprInfoPath = getPropertyFieldTprInfoPath(element?.path, propertyIndex);
        prepareObj(
          obj,
          element,
          { ...property, propertiesResults },
          toorakProduct,
          editHistory
        );
        propertyUnit.push(obj);
      }
    });

    propertyFields.push(propertyUnit);
  });

  addPropertyLevelBaseDataInfo(key, propertyFields, baseData?.properties, page);
  propertyFields.forEach((property: any) => {
    property.forEach((field: any) => {
      addMappings(field, counter, dataPoints, "Property", tagList);
      counter++;
    });
  });
  return {
    propertyFields,
    escrowPropObj
  };
};
export const getValueByPath = (obj: any, path: string): any => {
  if (!path) return undefined;
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

export const prepareCalculatedFieldsForRedux = (
  loanEvaluationResult: any,
  isDSCR: boolean,
  results: any
) => {
  const fieldSet: any = (
    (isDSCR ? DSCRCalculatedFields : BridgeCalculatedFields) as any[]
  ).filter(Boolean);

  const inputLoanResult = loanEvaluationResult?.loanResult;
  const calcLoanResult = results?.loanResult ?? results?.assignedTpResult?.loanResult

  const loanId = inputLoanResult
    ? Object.keys(inputLoanResult)[0]
    : calcLoanResult
    ? Object.keys(calcLoanResult)[0]
    : null;

  if (!loanId) {
    console.warn("No loan ID found in either loanEvaluationResult or results");
    return { calculatedFields: [] };
  }

  const flattenedInput: any = {
    loanResult: {
      loanEconomics: inputLoanResult?.[loanId]?.loanEconomics || {},
      loanCharacterisations:
        inputLoanResult?.[loanId]?.loanCharacterisations || {},
      loanFeatures: inputLoanResult?.[loanId]?.loanFeatures || {},
      guideLineLimit: inputLoanResult?.[loanId]?.guideLineLimit || {},
      logicTests: inputLoanResult?.[loanId]?.logicTests || {}
    },
    propertiesResults: loanEvaluationResult?.propertiesResults || {}
  };

  const flattenedCalculated: any = {
    loanResult: {
      loanEconomics: calcLoanResult?.[loanId]?.loanEconomics || {},
      loanCharacterisations:
        calcLoanResult?.[loanId]?.loanCharacterisations || {},
      loanFeatures: calcLoanResult?.[loanId]?.loanFeatures || {},
      guideLineLimit: calcLoanResult?.[loanId]?.guideLineLimit || {},
      logicTests: calcLoanResult?.[loanId]?.logicTests || {}
    },
    propertiesResults: results?.propertiesResults || {}
  };

  const calculatedFields: any[] = [];

  for (const field of fieldSet) {
    const {
      path,
      key,
      label,
      field: fieldKey,
      type,
      rulesKey,
      aliasKey,
      disableAfterApproved,
      values,
      skipRules,
      formulaVariables,
      formulaText
    } = field;

    if (Array.isArray(key)) {
      const inputObject: any = flattenedInput[path];
      const calcObject: any = flattenedCalculated[path];
      if (typeof inputObject !== "object" || typeof calcObject !== "object")
        continue;

      let propertyIndex = 0;

      Object.entries(inputObject).forEach(
        ([loanPropertyId, inputResult]: [string, any]) => {
          const calcResult = calcObject?.[loanPropertyId] || {};
          propertyIndex++;

          key.forEach((nestedKey: string, j: number) => {
            const inputPath = `${path}.${loanPropertyId}.${nestedKey}.${fieldKey[j]}`;
            const calcPath = `${path}.${loanPropertyId}.${nestedKey}.${fieldKey[j]}`;

            const userInputValue = resolveSmartPath(inputPath, flattenedInput);
            const calculatedValue = resolveSmartPath(
              calcPath,
              flattenedCalculated
            );

            const disable = Array.isArray(disableAfterApproved)
              ? disableAfterApproved[j]
              : disableAfterApproved;

            calculatedFields.push({
              label: `Property ${propertyIndex} ${label?.[j] ?? ""}`.trim(),
              path: inputPath,
              field: fieldKey[j],
              aliasKey: aliasKey?.[j],
              rulesKey: rulesKey?.[j],
              type: type?.[j],
              disableAfterApproved: disable,
              values: values?.[j],
              skipRules: skipRules?.[j],
              loanPropertyId,
              formulaVariables: formulaVariables?.[j],
              formulaText: formulaText?.[j],
              sourceFromUserInput: userInputValue
                ? formatValueByType(userInputValue, type?.[j])
                : null,
              calculatedResult: calculatedValue
                ? formatValueByType(calculatedValue, type?.[j])
                : null
            });
          });
        }
      );
    } else {
      const inputValue = getValueByPath(flattenedInput, path);
      const calcValue = getValueByPath(flattenedCalculated, path);

      calculatedFields.push({
        ...field,
        sourceFromUserInput: inputValue
          ? formatValueByType(
              inputValue.toString(),
              typeof type === "string" ? type : ""
            )
          : null,
        calculatedResult: calcValue
          ? formatValueByType(
              calcValue.toString(),
              typeof type === "string" ? type : ""
            )
          : null
      });
    }
  }

  return {
    calculatedFields
  };
};

export const setValueToField = (
  obj: ObjectType,
  keyPath: string[],
  value: any
) => {
  if (
    ["businessPurposeOccupancy", "subordinateFinancing", "isHardPull"].includes(
      keyPath?.[1]
    )
  ) {
    if (value === "Yes") {
      value = true;
    } else if (value === "No") {
      value = false;
    }
  }
  const lastKeyIndex = keyPath.length - 1;
  for (let i = 0; i < lastKeyIndex; ++i) {
    const key = keyPath[i];
    if (!(key in obj)) {
      obj[key] = {};
    }
    obj = obj[key];
  }
  obj[keyPath[lastKeyIndex]] = value;
};
export const setValueToFieldV2 = (
  obj: ObjectType,
  keyPath: (string | number)[],
  value: any
) => {
  const creditBureaus = ["TransUnion", "Equifax", "Experian"];
  const lastKeyIndex = keyPath.length - 1;

  let current = obj;

  for (let i = 0; i < lastKeyIndex; ++i) {
    const key = keyPath[i];

    const prevKey = keyPath[i - 1];
    const nextKey = keyPath[i + 1];
    if (
      prevKey === "creditInformation" &&
      creditBureaus.includes(key as string)
    ) {
      if (!Array.isArray(current)) {
        current = [];
        if (i >= 2) {
          const parentKey = keyPath[i - 2];
          obj[parentKey][prevKey] = current;
        } else {
          obj[prevKey] = current;
        }
      }

      const bureau = key as string;

      let target = current.find((entry: any) => entry.creditFirm === bureau);

      if (!target) {
        target = { creditFirm: bureau };
        current.push(target);
      }

      target[nextKey as string] = value;
      return;
    }

    if (!(key in current)) {
      current[key] = {};
    }

    current = current[key];
  }

  current[keyPath[lastKeyIndex]] = value;
  // console.log("setValueToFieldV2", obj);
};
export const setValueToFieldV3 = (
  obj: Record<string, any>,
  keyPath: (string | number)[],
  value: any
) => {
  // console.log("setValueToFieldV3", { obj, keyPath, value });
  const creditBureaus = ["TransUnion", "Equifax", "Experian"];
  const lastKeyIndex = keyPath.length - 1;

  let current: any = obj;

  for (let i = 0; i < lastKeyIndex; ++i) {
    let key: string | number = keyPath[i];
    const nextKey = keyPath[i + 1];
    const prevKey = keyPath[i - 1];

    // Convert numeric string keys to actual numbers for arrays
    const isNumericKey = !isNaN(Number(key));
    if (isNumericKey) key = Number(key);

    // Special handling for credit bureau structure
    if (
      prevKey === "creditInformation" &&
      creditBureaus.includes(key as string)
    ) {
      if (!Array.isArray(current)) {
        current = [];
        if (i >= 2) {
          const parentKey = keyPath[i - 2];
          obj[parentKey][prevKey] = current;
        } else {
          obj[prevKey] = current;
        }
      }

      const bureau = key as string;
      let target = current.find((entry: any) => entry.creditFirm === bureau);

      if (!target) {
        target = { creditFirm: bureau };
        current.push(target);
      }

      target[nextKey as string] = value;
      return;
    }

    // Initialize the next level if it doesn't exist
    if (typeof current[key] === "undefined") {
      const isNextKeyNumeric = !isNaN(Number(nextKey));
      current[key] = isNextKeyNumeric ? [] : {};
    }

    current = current[key];
  }

  const finalKey = keyPath[lastKeyIndex];
  current[finalKey] = value;
};

export const createSavePayload = (
  loanFields: any,
  userFields: any,
  propertyFields: any[],
  valueType: string,
  isNormalFlow = true,
  loanId?: string
) => {
  const payload: any = { loans: { loanUserMap: [] }, properties: [] };
  const creditBureauFields = ["Equifax", "Experian", "TransUnion"];
  const valuationFields = [
    "appraisalType",
    "appraisalAsIsValue",
    "appraisalDate",
    "appraisalArvValue"
  ];
  loanFields.forEach((field: any) => {
    let { path } = field;
    if (path.includes("[loanId]") && loanId) {
      path = path.replace("[loanId]", `${loanId}`);
    }
    setValueToField(payload.loans, path?.split("."), field[valueType]);
  });
  if (payload?.loans?.loanEconomics?.originalMonthlyPiPayment === "") {
    payload.loans.loanEconomics.originalMonthlyPiPayment = null;
  }
  const loanResultData = payload?.loans?.loanResults?.loanResult?.[`[loanId]`]  ?? payload?.loans?.loanResults?.loanResult?.[`${loanId}`] ?? {}
  if (!payload.loans.loanResults) {
    payload.loans.loanResults = {};
  }
  payload.loans.loanResults.loanResult = {
    [`${loanId}`] : { ...loanResultData }
  }
  userFields.forEach((field: any) => {
    if (payload.loans.loanUserMap[field.index] === undefined) {
      payload.loans.loanUserMap[field.index] = {
        loanUserMapId: field.loanUserMapId,
        loanUserSequence: field.loanUserSequence,
        partyId: field.partyId,
        ...(isNormalFlow && { isPrimary: field.isPrimary }),
        loanUserType: field.userType,
        customer: {
          contactList: [{}],
          addressList: [{}],
          ...(isNormalFlow && { partyType: field.partyType })
        }
      };
    }
    if (creditBureauFields.includes(field.field)) {
      // console.log("creditBureauFields",payload.loans.loanUserMap[field.index],);
      setValueToFieldV2(
        payload.loans.loanUserMap[field.index],
        field.path.split("."),
        field[valueType]
      );
    } else
      setValueToField(
        payload.loans.loanUserMap[field.index],
        field.path.split("."),
        field?.type === "dateOnly" ? field[valueType] || null : field[valueType]
      );
  });
  propertyFields.forEach((property: any) => {
    property.forEach((dataPoint: any) => {
      if (dataPoint.unitIndex === undefined) {
        if (payload.properties[dataPoint.propertyIndex] === undefined) {
          payload.properties[dataPoint.propertyIndex] = {
            loanPropertyId: dataPoint.loanPropertyId,
            loanPropertyOrder: dataPoint.loanPropertyOrder
          };
        }
        const isValuationField = valuationFields.includes(dataPoint.field);
        const pathParts = dataPoint.path.split(".");

        if (isValuationField && pathParts[0] === "valuations") {
          const valuationIndex = parseInt(pathParts[1], 10) - 1;
          if (!payload.properties[dataPoint.propertyIndex].valuations) {
            payload.properties[dataPoint.propertyIndex].valuations = [];
          }
          if (
            !payload.properties[dataPoint.propertyIndex].valuations[
              valuationIndex
            ]
          ) {
            payload.properties[dataPoint.propertyIndex].valuations[
              valuationIndex
            ] = {
              valuationOrder: valuationIndex + 1
            };
          }
          setValueToField(
            payload.properties[dataPoint.propertyIndex].valuations[
              valuationIndex
            ],
            [dataPoint.field],
            dataPoint[valueType]
          );
        } else {
          setValueToField(
            payload.properties[dataPoint.propertyIndex],
            pathParts,
            dataPoint?.type === "dateOnly"
              ? dataPoint[valueType] || null
              : dataPoint[valueType]
          );
        }

        if (dataPoint.field === "addressLine1" && isNormalFlow) {
          const path = "propertyLocation.locationValidationStatus";
          setValueToField(
            payload.properties[dataPoint.propertyIndex],
            path.split("."),
            dataPoint.locationValidationStatus
          );
        }
      } else {
        if (
          payload.properties[dataPoint.propertyIndex].propertyUnit === undefined
        ) {
          payload.properties[dataPoint.propertyIndex].propertyUnit = [];
        }
        if (
          payload.properties[dataPoint.propertyIndex].propertyUnit[
            dataPoint.unitIndex
          ] === undefined
        ) {
          payload.properties[dataPoint.propertyIndex].propertyUnit[
            dataPoint.unitIndex
          ] = {
            propertyUnitId: dataPoint.propertyUnitId,
            propertyUnitOrder: dataPoint.propertyUnitOrder
          };
        }
        setValueToField(
          payload.properties[dataPoint.propertyIndex].propertyUnit[
            dataPoint.unitIndex
          ],
          [dataPoint.field],
          dataPoint?.type === "dateOnly"
            ? dataPoint[valueType] || null
            : dataPoint[valueType]
        );
      }
    });
  });
  return payload;
};

export const createExtractPayload = (
  loanFields: any,
  userFields: any,
  propertyFields: any[]
) => {
  let obj = createSavePayload(
    loanFields,
    userFields,
    propertyFields,
    "extractedInfoDB",
    false
  );
  obj = cleanObject(JSON.parse(JSON.stringify(obj)));
  if (obj?.loans?.loanUserMap) {
    obj.loanUserMap = obj?.loans?.loanUserMap;
    delete obj.loans.loanUserMap;
  }
  return obj;
};

export const updateSubmitPayload = (
  submitPayload: any,
  element: any,
  isPostApprovalAndShouldBeDisabled: boolean,
  isPartialSubmit = 0,
  override?: boolean
) => {
  if (
    ((isPartialSubmit && element?.checked) || !isPartialSubmit) &&
    (override ||
      (element?.documentInfo !== "" &&
        element?.documentInfo != null &&
        // eslint-disable-next-line
        element?.documentInfo != element?.loanInfo)) &&
        (element?.type !== "nonEditable" && !element?.isReadOnlyField) &&
    (!element?.disableAfterApproved ||
      (element?.disableAfterApproved &&
        (!isPostApprovalAndShouldBeDisabled ||
          (isPartialSubmit && element?.checked))))
    || element?.forceAddToSubmitPayload
  ) {
    const value =
      element?.field === "isHardPull"
        ? element?.documentInfoDB === "Yes"
        : element?.documentInfoDB;
    const obj: any = {
      field: element?.field,
      path: element?.path,
      auditPath: element?.auditPath,
      value,
      valueForComment: element?.documentInfo,
      comment: element?.comment || defaultComment.updatedThroughTTF,
      type: element?.type,
      label: element?.label,
      ...(element?.loanUserMapId !== undefined && {
        loanUserMapId: element?.loanUserMapId
      }),
      ...(element?.loanUserSequence !== undefined && {
        loanUserSequence: element?.loanUserSequence
      }),
      ...(element?.partyId !== undefined && {
        partyId: element?.partyId
      }),
      ...(element?.loanPropertyId !== undefined && {
        loanPropertyId: element?.loanPropertyId
      }),
      // index of property unit
      ...(element?.unitIndex !== undefined && {
        unitIndex: element?.unitIndex
      }),
      // alias key is the name of the field in the reducer/audit. if no alias key, then field name to be used
      ...(element?.aliasKey !== undefined && {
        aliasKey: element?.aliasKey
      }),
      ...(element?.rulesKey !== undefined && {
        rulesKey: element?.rulesKey
      }),
      ...(element?.skipRules !== undefined && {
        skipRules: element?.skipRules
      }),
      ...(element?.locationValidationStatus !== undefined && {
        locationValidationStatus: element?.locationValidationStatus
      })
    };
    if(element?.op) {
      obj.op = element?.op
    }
    submitPayload.push(obj);
  }
};

export const transformSubmitPayload = (submitPayload: any, isDSCR: boolean) => {
  // Single Family Detached to be saved as SFR in backend. This check should be removed
  // and handled from BE.
  const submitPayloadLoc = submitPayload.map((obj: any) => {
    if (
      obj?.field === "propertyType" &&
      obj?.value === "Single Family Detached"
    ) {
      obj.value = "SFR";
    }
    return obj;
  });

  return submitPayloadLoc;
};

export const getLeaseStatusDropdown = (loanRuleVersions: any) => {
  const defaultDropdown = rentDescription.map((item: any) => ({
    value: item,
    label: item
  }));
  const dropdownData = getDropDownData(
    "leaseStatus",
    defaultDropdown,
    loanRuleVersions
  );
  return dropdownData.map((item: any) => item.value);
};

export const updateAddress = (propertyDetails: any) => {
  const address: any[] = [];
  const sortedPropertyDetails = sortByKey(
    propertyDetails,
    "loanPropertyOrder",
    "loanPropertyId"
  );
  sortedPropertyDetails.forEach((property: any) => {
    let fullAddress = [
      property.propertyLocation?.addressNumber,
      property.propertyLocation?.addressLine1,
      property.propertyLocation?.addressLine2,
      property.propertyLocation?.addressLine3,
      property.propertyLocation?.city,
      property.propertyLocation?.state
    ]
      .filter(Boolean)
      .join(", ");
    if (property.propertyLocation?.postalCode) {
      fullAddress += ` ${property.propertyLocation?.postalCode}`;
    }
    address.push({
      value: fullAddress,
      assetExternalId: property.loanPropertyOrder,
      assetName: DOC_MAPPING_ENTITIES.property
    });
  });
  return address;
};

export const formatAddressFromRedux = (propertyDetails: any) => {
  const address: any = [];
  propertyDetails.forEach((property: any) => {
    let fullAddress = [
      property.propertyLocation.payload.address.street_line,
      property.propertyLocation.payload.address.city,
      property.propertyLocation.payload.address.state
    ]
      .filter(Boolean)
      .join(", ");
    if (property.propertyLocation?.payload.address.zipcode) {
      fullAddress += ` ${property.propertyLocation?.payload?.address?.zipcode}`;
    }
    address.push({
      value: fullAddress,
      assetExternalId: property.loanPropertyOrder,
      assetName: DOC_MAPPING_ENTITIES.property
    });
  });
  return address;
};

export const areThereRequiredBudgetDocs = (
  isDSCR: boolean,
  documentList: AutomaticTaggedDocumentType[],
  address: ObjectType[]
) => {
  const budgetMessage: string[] = [];
  let flag = true;
  if (isDSCR) {
    return [];
  }
  const budgetDocs = documentList?.filter(
    (document: AutomaticTaggedDocumentType) =>
      ["REBD", "SCOW"].includes(document.TagsInternal[0]?.tag?.code)
  );
  if (address?.length > budgetDocs?.length) {
    return [
      "Number of Budget Documents are less than the number of properties in this loan."
    ];
  }
  address.forEach((property: ObjectType, index: number) => {
    const propertyBudget = budgetDocs.filter(
      (document: AutomaticTaggedDocumentType) =>
        (Array.isArray(document?.assets) ? document?.assets : [])?.find(
          (asset: ObjectType) =>
            asset?.assetExternalId?.toString() ===
              property?.assetExternalId?.toString() &&
            asset?.assetName === "PROPERTY" &&
            document.isPurchasePrimary
        )
    );
    if (propertyBudget.length === 0) {
      flag = false;
      budgetMessage.push(
        `Property ${index + 1} - ${
          property.value
        } - Primary budget document not found.`
      );
    } else if (propertyBudget.length > 1) {
      flag = false;
      budgetMessage.push(
        `Property ${index + 1} - ${
          property.value
        } - More than one primary budget document found.`
      );
    }
  });
  if (flag) {
    return [];
  }
  return budgetMessage;
};

export const userFieldsInfo = (userFields: any, userType: string) => {
  let firstName = "";
  let fullName = "";
  let firstNameIndex: number;
  let fullNameArray: any[] = [];
  if (userFields?.length) {
    userFields.forEach((item: any) => {
      if (item.userType === userType) {
        if (item.field === "firstName") {
          firstName = item.loanInfo;
          firstNameIndex = item.index;
        } else if (item.field === "lastName" && item.index === firstNameIndex) {
          fullName = `${firstName} ${item.loanInfo}`;
          if (fullName !== " ") {
            fullNameArray = [
              ...fullNameArray,
              {
                value: fullName,
                assetExternalId: item.partyId,
                assetName: userType.toUpperCase()
              }
            ];
          }
        } else if (item.field === "accountName") {
          if (item.loanInfo && item.loanInfo !== " ") {
            fullNameArray = [
              ...fullNameArray,
              {
                value: item.loanInfo,
                assetExternalId: item.partyId,
                assetName: userType.toUpperCase()
              }
            ];
          }
        }
      }
    });
  }
  return fullNameArray;
};

const getAddressComponents = (value: string) => {
  const splitUp = value.split(", ");
  if (value && splitUp?.length >= 4) {
    return {
      city: splitUp[splitUp.length - 3],
      state: splitUp[splitUp.length - 2],
      pincode: splitUp[splitUp.length - 1]
    };
  }
  return {
    city: "",
    state: "",
    pincode: ""
  };
};

const setUserBaseData = (
  userMap: ObjectType[],
  field: ObjectType,
  valueType: string,
  key: string,
  skipFormat: boolean,
  loanDetails: any,
  page: string
) => {
  const index = userMap.findIndex(
    (val: ObjectType) => val[key] != null && val[key] === field[key]
  );
  if (index !== -1) {
    addBaseDataInfo(
      valueType,
      field,
      userMap[index],
      skipFormat,
      page,
      "",
      loanDetails
    );
  }
  return index;
};

const setBorrowerPayload = (
  borrowerInfoTTF: ObjectType,
  item: ObjectType,
  field: string,
  key: string,
  secondaryKey?: string
) => {
  const itemKey = secondaryKey ?? key;
  const index = borrowerInfoTTF.findIndex(
    (borrower: ObjectType) =>
      item[itemKey] != null && borrower.payload[key] === item[itemKey]
  );
  if (index !== -1) {
    let { value } = item;
    if (field === "billingAddress") {
      value = getFormattedAddress(item.value, true);
      const { city, state, pincode } = getAddressComponents(value);
      borrowerInfoTTF[index].payload.city = city;
      borrowerInfoTTF[index].payload.state = state;
      borrowerInfoTTF[index].payload.pincode = pincode;
      borrowerInfoTTF[index].payload.locationValidationStatus = "OVERRIDDEN";
    }
    borrowerInfoTTF[index].payload[field] = value;
  }
  return index;
};

const setGuarantorPayload = (
  guarantorInfoTTF: ObjectType,
  item: ObjectType,
  field: string,
  key: string,
  secondaryKey?: string
) => {
  const itemKey = secondaryKey ?? key;
  const index = guarantorInfoTTF.findIndex(
    (guarantor: ObjectType) =>
      item[itemKey] != null && guarantor.payload[key] === item[itemKey]
  );
  if (index !== -1) {
    guarantorInfoTTF[index].payload[field] = item.value;
  }
  return index;
};

const processPayload = (
  payloadArray: ObjectType[],
  item: ObjectType,
  field: string,
  primaryKey: string,
  secondaryKey: string,
  tertiaryKey: string,
  payloadFunction: Function
) => {
  let index = payloadFunction(payloadArray, item, field, primaryKey);
  if (index === -1) {
    index = payloadFunction(
      payloadArray,
      item,
      field,
      secondaryKey,
      "loanUserSequence"
    );
  }
  if (index === -1) {
    payloadFunction(payloadArray, item, field, tertiaryKey);
  }
};

export const preparePayload = (
  item: ObjectType,
  isDSCR: boolean,
  bridgeLoanEconomicsTTF: ObjectType,
  thirtyYearLoanEconomicsTTF: ObjectType,
  bridgeLoanInformationTTF: ObjectType,
  thirtyYearLoanInformationTTF: ObjectType,
  bridgeLoanBorrowerInformationTTF: ObjectType,
  bridgeLoanGuarantorInformationTTF: ObjectType,
  propertyDetailsInformationTTF: ObjectType,
  loanSummaryTTF: ObjectType,
  loanFeesTTF: ObjectType,
  achDataTTF: ObjectType,
  bridgeLoanDetailIdTTF: ObjectType,
  thirtyYearLoanDetailIdTTF: ObjectType
) => {
  const field = item.aliasKey !== undefined ? item.aliasKey : item.field;
  const payloadObject: ObjectType = {
    Borrower: {
      payloadArray: bridgeLoanBorrowerInformationTTF,
      payloadFunction: setBorrowerPayload,
      secondaryKey: "borrowerLoanUserSequence"
    },
    Guarantor: {
      payloadArray: bridgeLoanGuarantorInformationTTF,
      payloadFunction: setGuarantorPayload,
      secondaryKey: "guarantorLoanUserSequence"
    }
  };

  if (item.path.startsWith("loanDetailId.loanSummaryId")) {
    loanSummaryTTF[field] = item.value;
  } else if (item.path.startsWith("loanFees")) {
    loanFeesTTF[field] = item.value;
  } else if (item.path.startsWith("achData")) {
    achDataTTF[field] = item.value;
  } else if (item.path.startsWith("loanEconomics")) {
    if (
      ["businessPurposeOccupancy", "subordinateFinancing"].includes(item.field)
    ) {
      if (item.value === true) {
        item.value = "Yes";
      } else if (item.value === false) {
        item.value = "No";
      }
    }
    if (!isDSCR) {
      bridgeLoanEconomicsTTF.payload[field] = item.value;
    } else {
      thirtyYearLoanEconomicsTTF.payload[field] = item.value;
    }
  } else if (item.path.startsWith("loanInfo")) {
    if (item.field === "crossCollaterlization") {
      if (["true", true, "Yes"].includes(item.value)) {
        item.value = "Y";
      } else if (["false", false, "No"].includes(item.value)) {
        item.value = "N";
      }
    }
    if (!isDSCR) {
      bridgeLoanInformationTTF.payload[field] = item.value;
    } else {
      thirtyYearLoanInformationTTF.payload[field] = item.value;
    }
    /* eslint-disable eqeqeq */
  } else if (
    item.partyId != undefined ||
    item.loanUserSequence != undefined ||
    item.loanUserMapId != undefined
    /* eslint-enable eqeqeq */
  ) {
    for (const key in payloadObject) {
      if (item.label.startsWith(key)) {
        const { payloadArray, payloadFunction, secondaryKey } =
          payloadObject[key];
        processPayload(
          payloadArray,
          item,
          field,
          "partyId",
          secondaryKey,
          "loanUserMapId",
          payloadFunction
        );
      }
    }
  } else if (item.path.startsWith("property")) {
    const propertyIndex = propertyDetailsInformationTTF.findIndex(
      (property: any) => property.propertyId === item.loanPropertyId
    );
    if (propertyIndex !== -1) {
      if (item.path.startsWith("propertyinfo")) {
        propertyDetailsInformationTTF[
          propertyIndex
        ].propertyInformation.payload[field] = item.value;
        if(item?.field === "propertyUnits") {
            propertyDetailsInformationTTF[
              propertyIndex
            ].propertyInformation.payload[item?.aliasKey || field] = item.value
          }
      } else if (item.path.startsWith("propertyEconomics")) {
        propertyDetailsInformationTTF[propertyIndex].propertyEconomics.payload[
          field
        ] = item.value;
      } else if (item.path.startsWith("propertyUnit")) {
        propertyDetailsInformationTTF[propertyIndex].unitsInformation[
          item.unitIndex
        ].payload[field] = item.value;
      } else if (item.path.startsWith("propertyLocation")) {
        if (item.field === "addressLine1") {
          propertyDetailsInformationTTF[
            propertyIndex
          ].propertyLocation.payload.address[field] = item.value;
        } else {
          propertyDetailsInformationTTF[propertyIndex].propertyLocation.payload[
            field
          ] = item.value;
          propertyDetailsInformationTTF[
            propertyIndex
          ].propertyLocation.payload.locationValidationStatus =
            item.locationValidationStatus;
        }
      }
    }
  } else if (item.path.startsWith("valuations")) {
    const propertyIndex = propertyDetailsInformationTTF.findIndex(
      (property: any) => property.propertyId === item.loanPropertyId
    );

    if (propertyIndex !== -1) {
      const splitPath = item.path.split(".");
      const valuationOrder = Number(splitPath[1]);
      const { valuations } = propertyDetailsInformationTTF[propertyIndex];

      const valuation = valuations.find(
        (v: any) => v.payload?.valuationOrder === valuationOrder
      );

      if (valuation) {
        valuation.payload[field] = item.value;
      } else if(item?.op === "add") {
        const findIndex = propertyDetailsInformationTTF[propertyIndex].valuations?.findIndex((v: any) => v?.payload?.op === "add")
        if(findIndex !== -1) {
          propertyDetailsInformationTTF[propertyIndex].valuations[findIndex] = {
            ...propertyDetailsInformationTTF[propertyIndex].valuations[findIndex],
            payload: {
              ...propertyDetailsInformationTTF[propertyIndex].valuations[findIndex]?.payload,
              [field]: item.value
            }
          }
        } else {
            propertyDetailsInformationTTF[propertyIndex].valuations.push({
              error: null,
              payload: {
                op: "add",
                [field]: item.value,
                appraisalType: "Desk Review"
              }
          })
        }
      } else {
        console.warn(`Valuation with order ${valuationOrder} not found.`);
      }
    }
  } else if (item.path.startsWith("loanDetailId.discountPointPercentage")) {
    if (!isDSCR) {
      bridgeLoanDetailIdTTF.payload[field] = item.value;
    } else {
      thirtyYearLoanDetailIdTTF.payload[field] = item.value;
    }
  } else if (item.path.startsWith("loanDetailId.originationPointPercentage")) {
    if (!isDSCR) {
      bridgeLoanDetailIdTTF.payload[field] = item.value;
    } else {
      thirtyYearLoanDetailIdTTF.payload[field] = item.value;
    }
  } else if (item.path.startsWith("loanDetailId.discountPointAmount")) {
    if (!isDSCR) {
      bridgeLoanDetailIdTTF.payload[field] = item.value;
    } else {
      thirtyYearLoanDetailIdTTF.payload[field] = item.value;
    }
  }
  // console.log("propertyDetailsInformationTTF",{propertyDetailsInformationTTF,item});
};

export const getFieldName = (obj: any) => {
  const fullPath = obj.auditPath;
  if (obj.loanUserMapId !== undefined) {
    fullPath.replace(".0.", "[0]");
    return `data.loan.loanUserMap[${obj.loanUserMapId}].${fullPath}`;
  }
  if (obj.unitIndex !== undefined) {
    return `data.properties[${obj.loanPropertyId}].propertyUnit[${
      obj.unitIndex
    }].${fullPath.split(".")[2]}`;
  }
  if (obj.loanPropertyId !== undefined) {
    return `data.properties[${obj.loanPropertyId}].${fullPath}`;
  }
  if(obj.field==="currentLoanBalance"){
    return `data.${fullPath}`

  }
  return `data.loan.${fullPath}`;
};

export const prepCommentObj = (item: any, personId: any) => {
  let { value, comment, valueForComment } = item;
  if (["crossCollaterlization"].includes(item.field)) {
    if (["true", true, "Yes"].includes(value)) {
      value = "Y";
    } else if (["false", false, "No"].includes(value)) {
      value = "N";
    }
  } else if (
    ["businessPurposeOccupancy", "subordinateFinancing"].includes(item.field)
  ) {
    if (value === true) {
      value = "Yes";
    } else if (value === false) {
      value = "No";
    }
  }
  if (item.type === "currency") {
    value = `$${value}`;
  } else if (item.type === "percentage") {
    value = `${value}%`;
  } else if (item.type === "number" || item.type === "date") {
    value = valueForComment;
  }
  return {
    value,
    comment,
    updatedBy: personId,
    field: getFieldName(item)
  };
};

export const findMinMax = (arr: any[], key: string) => {
  let min = arr?.[0]?.[key];
  let max = arr?.[0]?.[key];

  for (let i = 1, len = arr?.length; i < len; i++) {
    const v = arr?.[i]?.[key];
    min = v < min ? v : min;
    max = v > max ? v : max;
  }

  return { min, max };
};

export const prepareForSaveToDB = (type: any, readVal: any, newVal: any) => {
  switch (type) {
    case "dateOnly": {
      // Ensure only the "YYYY-MM-DD" portion is returned if there's a time component
      return newVal ? newVal.split(" ")[0] : "";
    }
    case "date": {
      // Check if newVal already contains a time component (e.g., 'T00:00:00')
      if (newVal && newVal.includes("T")) {
        return newVal; // If it already contains a time, return as is
      }
      return newVal ? `${newVal}T00:00:00.000Z` : "";
    }
    case "dropdown": {
      if (readVal === "Y") {
        return true;
      }
      if (readVal === "N") {
        return false;
      }
      return readVal;
    }
    default: {
      return readVal;
    }
  }
};

export const sortByKey = (
  obj: any,
  primaryKey: string,
  secondaryKey: string
) => {
  const newObj = JSON.parse(JSON.stringify(obj));
  return newObj.sort((a: any, b: any) => {
    if (!isEmptyValue(a?.[primaryKey]) && !isEmptyValue(b?.[primaryKey])) {
      return parseInt(a[primaryKey]) - parseInt(b[primaryKey]);
    }
    if (!isEmptyValue(a?.[secondaryKey]) && !isEmptyValue(b?.[secondaryKey])) {
      return parseInt(a[secondaryKey]) - parseInt(b[secondaryKey]);
    }
    return 0;
  });
};

export const updateAndRunRules = async (
  dispatch: any,
  documentReviewDispatch: any,
  changedRulesFields: any[],
  waiversCreated: any,
  loanId: string,
  loanStage: LoanStage,
  loanType: string,
  overriddenValues: any,
  bridgeLoanGuarantorInformationTTF: any,
  bridgeLoanBorrowerInformationTTF: any,
  thirtyYearLoanInformationTTF: any,
  thirtyYearLoanEconomicsTTF: any,
  bridgeLoanInformationTTF: any,
  bridgeLoanEconomicsTTF: any,
  propertyDetailsInformationTTF: any,
  loanRuleVersions: any,
  loanSummaryTTF: any,
  loanConfigTTF: any,
  loanFeesTTF: any,
  achDataTTF: any,
  loanEvaluationResult: any,
  loanParamChanged: boolean,
  propertyParamChanged: boolean,
  commentObj: any[],
  toBeSubmittedData: any,
  updateLoanCallback: any,
  updatePropertyCallback: any,
  bridgeLoanDetailIdTTF: any,
  thirtyYearLoanDetailIdTTF: any,
  takeoutPartnerId: any,
  existingLoanDetails: any,
  saveObj?: ObjectType,
  onlyTriggeringRulesAndSave = false,
  actionType?: docReviewActionTypeEnum,
  calculatedFields?: any,
  loanFields?: any,
  submitRecon?: boolean,
  page?: string,
  isPostApprovalLoanState?: boolean,
  loanDetails?: any,
  submitPayloadLoc?: any
) => {
  const isDSCR = loanType.includes("DSCR");
  let overriddenValuesToUse: any = overriddenValues;
  const initializer = { reRequestWaiverObject: {}, openWaivers: [] };
  let { reRequestWaiverObject, openWaivers }: any = initializer;
  let refreshWaiver = false;
  let allSuccess = true
  if (changedRulesFields.length) {
    ({ reRequestWaiverObject, openWaivers } = await getAffectedWaivers(
      changedRulesFields,
      waiversCreated,
      loanId,
      loanStage,
      loanType
    ));
    refreshWaiver =
      (typeof reRequestWaiverObject === "object" &&
        Object.keys(reRequestWaiverObject)?.length) ||
      openWaivers.length;
    // skipping when no partner and loan is of dscr
    // https://toorakcapital.atlassian.net/browse/TA-4313
    if (
      refreshWaiver &&
      (loanType === getLoanType[0].displayValue ||
        (loanType === getLoanType[1].displayValue && takeoutPartnerId))
    ) {
      const resp = await getOverriddenOutputs(
        loanId,
        loanStage,
        takeoutPartnerId
      );
      overriddenValuesToUse = resp?.data;
      if (!onlyTriggeringRulesAndSave) {
        dispatch(updateOverriddenInredux(resp));
      }
    }
  }
  const bridgeLoanGuarantorInformationToPass =
    getBridgeLoanGuarantorInformationToPass(bridgeLoanGuarantorInformationTTF);
  const data = getLoanPayLoadData(
    loanRuleVersions,
    loanSummaryTTF,
    loanFeesTTF,
    achDataTTF,
    isDSCR,
    bridgeLoanBorrowerInformationTTF,
    bridgeLoanGuarantorInformationTTF,
    thirtyYearLoanInformationTTF,
    thirtyYearLoanEconomicsTTF,
    bridgeLoanInformationTTF,
    bridgeLoanEconomicsTTF,
    bridgeLoanDetailIdTTF,
    thirtyYearLoanDetailIdTTF
  );
  const commonPayload = {
    loanId,
    loanType,
    loanConfig: loanConfigTTF,
    loanSummary: loanSummaryTTF,
    loanFees: loanFeesTTF,
    achData: achDataTTF,
    borrowerInformation: bridgeLoanBorrowerInformationTTF,
    guarantorInfo: bridgeLoanGuarantorInformationToPass
  };

  if (onlyTriggeringRulesAndSave) {
    try {
      const { evaluate, loanEvaluationRequest } =
        await getEvaluationRequestBody(
          loanId,
          loanStage,
          data,
          loanEvaluationResult,
          propertyDetailsInformationTTF,
          loanType
        );
      if (evaluate && loanEvaluationRequest) {
        const loanEvaluationRequestLoc: any = { ...loanEvaluationRequest };
        loanEvaluationRequestLoc.ruleAttributs = {
          ruleGroup: [],
          ruleField: [],
          ruleResult: []
        };
        loanEvaluationRequestLoc.resultObject = overriddenValuesToUse;
        const skipRules = isPostApprovalLoanState && page === "reconcile";
        let bundleDetails: any = null;
        if(isPostApprovalLoanState && page === "reconcile") {
          try {
            bundleDetails = await getBundleLoanData(loanId, true)
          } catch (err) {
            console.error(err);
          }
        }
        const { data: results } = await dispatch(
          evaluateLoan(
            loanEvaluationRequestLoc,
            loanId,
            loanStage,
            true,
            false,
            propertyDetailsInformationTTF,
            refreshWaiver,
            false,
            false,
            null,
            null,
            () => {
              failureCallback(
                dispatch,
                documentReviewDispatch,
                submissionFailedMessage
              );
            },
            "",
            false,
            saveObj,
            actionType,
            submitRecon,
            skipRules,
            bundleDetails?.bundleId
          )
        );
        if (actionType) {
          const updatedFieldSet = JSON.parse(JSON.stringify(loanFields));
          const recalculatedLoanFields = updateLoanFieldsOnRecalculate(
            results?.documentInfo,
            updatedFieldSet,
            loanId
          );

          dispatch(
            updateFieldSet({
              updatedFieldSet: recalculatedLoanFields,
              tab: "loan"
            })
          );
        }

        if (actionType === docReviewActionTypeEnum.calculateData) {
          const enrichedCalculatedFields = enrichCalculatedFields(
            results?.documentInfo?.results,
            calculatedFields,
            loanId
          );

          dispatch(
            updateCalculatedData({
              calculatedFields: enrichedCalculatedFields
            })
          );
        }

        dispatch(hideLoader());

        if (actionType === docReviewActionTypeEnum.saveData) {
          saveFinalCallback(dispatch, documentReviewDispatch);
        }
        return {
          results,
          isSuccess: true
        };
      }
      return {
        results: {},
        isSuccess: false
      };
      // Uncomment if needed later:
      // setTimeout(() => {
      //   dispatch(getLoanHistory(`${loanId}_${loanStage}`));
      // }, 1000);
    } catch (error) {
      failureCallback(dispatch, documentReviewDispatch, somethingFailedMessage);
      return {
        results: {},
        isSuccess: false
      };
    }
  }
  const postLoanPayload = !isDSCR
    ? {
        ...commonPayload,
        ...bridgeLoanInformationTTF.payload,
        ...bridgeLoanEconomicsTTF.payload,
        ...bridgeLoanDetailIdTTF.payload
      }
    : {
        ...commonPayload,
        ...thirtyYearLoanInformationTTF.payload,
        ...thirtyYearLoanEconomicsTTF.payload,
        ...thirtyYearLoanDetailIdTTF.payload
      };

  const patchLoanPayload: any = {} 
  const saveObjData = page == "reconcile" ? saveObj?.submittedReconciledInfo : saveObj?.submittedDocumentInfo
  const {loanData, propertyData, propertiesResults} = preparePatchLoanPayloadData(saveObjData, loanId, loanDetails, page, submitPayloadLoc)
  if (page === "review") {
    loanData.loanDetailId = loanData.loanDetailId || {};
    loanData.loanDetailId.loanSummaryId = loanData.loanDetailId.loanSummaryId || {};
    loanData.loanDetailId.loanSummaryId.ttfReviewStatus = loanSummaryTTF?.ttfReviewStatus;
    loanData.loanResult = {
      [loanId]: loanData?.loanResultData ? loanData.loanResultData : {}
    }
  }
  delete loanData?.loanResultData
  
  const auditComments= prepareAuditCommentsForPatchLoanApi(commentObj, loanId)
  let loanSummaryObj;
  if (loanSummaryTTF) {
    loanSummaryObj = prepareLoanSummaryObj(loanSummaryTTF, "patch")
  }

  const creditEventFields = dateKeys?.map((date: any) => date?.dateKey)
  const loanUserMapData = loanData?.loanUserMap?.map((user: any) => {
    const obj = { ...user }
    if (creditEventFields.some(field => user?.customer?.[field])) {
      obj.customer.creditEvent = true;
      const firstKey = Object.keys(auditComments)[0];  
      const firstValue = auditComments[firstKey];  
      auditComments[`data.loan.loanUserMap[${user?.loanUserMapId}].customer.creditEvent`] = firstValue
    }
    return { ...obj }
  })

    patchLoanPayload.loanData = {
      loanId,
      loanTypeId: 2,
      loanType,
      loanConfig: loanConfigTTF,
      loanSummary: {
        ...loanSummaryObj,
        insuranceExpirationDate:
          loanSummaryObj?.insuranceExpirationDate?.split("T")[0]
      },
      loanUserMap: loanUserMapData,
      ...loanData
    }
    patchLoanPayload.propertyData = propertyData

  if(!auditComments?.["data.loan.loanInfo.firstPaymentDateOfLoan"]) {
    delete loanData?.loanInfo?.firstPaymentDateOfLoan
  }
    
  const promise1 = loanParamChanged || propertyParamChanged
      ? patchLoanData(
          { ...patchLoanPayload, 
            loanState: loanDetails?.loanState, 
            op: "replace", 
            auditComments
          },
          ["BridgeLoan", LoanTypeEnum.BRIDGE].includes(loanType) ? "bridge" : "dscr",
          loanId,
          loanStage,
          loanDetails?.loanSizerType,
          true,
          loanDetails
        )
    : Promise.resolve("Success");

  // const promise2 =
  //   !propertyParamChanged || page === "reconcile"
  //     ? Promise.resolve("Success")
  //     : postPropertyData(
  //         loanId,
  //         loanStage,
  //         propertyDetailsInformationTTF,
  //         null,
  //         false,
  //         true,
  //         false,
  //         commentObj
  //       );

  return Promise.all([promise1])
    .then(
      async (responseArr: any) => {
        let rulesResponse;
        try {
          if(Object.keys(propertiesResults ?? {})?.length) {
            const propertyResultsAudits = Object.fromEntries(
              Object.entries(auditComments).filter(([key]) =>
                key.includes("propertiesResults")
              )
            );
            await postOverrideOutput(loanId, loanStage, {
                      propertiesResults,
                      auditContext: {
                        auditComments: propertyResultsAudits ?? {},
                        skipAudit: false
                      }
                    });
          }
          if (changedRulesFields.length) {
            const { evaluate, loanEvaluationRequest } =
              await getEvaluationRequestBody(
                loanId,
                loanStage,
                data,
                loanEvaluationResult,
                propertyDetailsInformationTTF,
                loanType
              );

            if (evaluate && loanEvaluationRequest && page !== "reconcile") {
              const loanEvaluationRequestLoc: any = loanEvaluationRequest;
              loanEvaluationRequestLoc.ruleAttributs = {
                ruleGroup: [],
                ruleField: [],
                ruleResult: []
              };
              loanEvaluationRequestLoc.resultObject = overriddenValuesToUse;

              rulesResponse = await dispatch(
                evaluateLoan(
                  loanEvaluationRequestLoc,
                  loanId,
                  loanStage,
                  true,
                  false,
                  propertyDetailsInformationTTF,
                  refreshWaiver,
                  false,
                  false,
                  null,
                  null,
                  () => {
                    failureCallback(
                      dispatch,
                      documentReviewDispatch,
                      submissionFailedMessage
                    );
                  },
                  "",
                  true
                )
              );
            }
          }
          if (existingLoanDetails?.loanState === LoanStatusEnum.InitialReview) {
            logger.log(`updateAndRunRules | Loan ID: ${loanId} | calling moveToReviewInProgress after submit`, LoggerLevel.INFO, {
              loanId,
              loanStage,
              loanState: existingLoanDetails?.loanState,
              hasRulesResponse: !!rulesResponse,
              hasLoanEvaluationResult: !!loanEvaluationResult
            }, 'ttfHelperFunctions');

            moveToReviewInProgress(
              loanId,
              loanStage,
              isDSCR,
              existingLoanDetails,
              rulesResponse?.data?.resultData ?? loanEvaluationResult,
              dispatch,
              "Updated from Document Review tab by system as prerequisites were met.",
              {
                loanSummary: loanSummaryTTF
              }
            );
          } else {
            logger.log(`dispatchAndUpdate | Loan ID: ${loanId} | skipping moveToReviewInProgress - loanState is not InitialReview`, LoggerLevel.WARN, {
              loanId,
              loanState: existingLoanDetails?.loanState
            }, 'ttfHelperFunctions');
          }
          setTimeout(() => {
            dispatch(getLoanHistory(`${loanId}_${loanStage}`));
            dispatch(hideLoader());
          }, 1000);
          submitFinalCallback(dispatch, documentReviewDispatch);
          if (loanParamChanged) {
            // dispatch({
            //   type: POST_LOAN_SUCCESS,
            //   payload: {
            //     reservation: responseArr[0]
            //   }
            // });
            dispatch(postLoanSuccess({ reservation: responseArr[0] }));
            await callAggregateLoanService(
              dispatch,
              loanId,
              loanStage,
              loanType,
              toBeSubmittedData,
              updateLoanCallback,
              changedRulesFields,
              saveObj
            );
          }
          if (
            propertyParamChanged ||
            (changedRulesFields.includes("firstPaymentDateOfLoan") &&
              loanType.includes("DSCR"))
          ) {
            await callAggregatePropertyService(
              dispatch,
              loanId,
              loanStage,
              loanType,
              toBeSubmittedData,
              updatePropertyCallback,
              changedRulesFields,
              saveObj
            );
          }
        } catch (error) {
            allSuccess = false
        }
        if(!allSuccess) {
          failureCallback(
              dispatch,
              documentReviewDispatch,
              submissionFailedMessage
          );
        }
        dispatch(clearLoader());
        return {
          results: {},
          isSuccess: false,
          allSuccess
        };
      },
      (error: any) => {
        allSuccess = false;
        failureCallback(
            dispatch,
            documentReviewDispatch,
            submissionFailedMessage
        );
        dispatch(clearLoader());
        return {
          results: {},
          isSuccess: false,
          allSuccess
        };
      }
  );
};

export const getCalculatedData = async (
  dispatch: any,
  loanId: string,
  loanStage: LoanStage,
  loanType: string,
  requestBody: any,
  calculatedFields: any
) => {
  try {
    dispatch(showLoader(true));
    await getCalulatedDatafromRules(loanType, loanId, loanStage, requestBody);

    dispatch(hideLoader(true));
    // console.log("response", response);
  } catch (error) {
    dispatch(hideLoader(true));
  }
};

function enrichCalculatedFields(
  result: any,
  calculatedFields: any,
  loanId: any
) {
  // console.log("resultedxvbcvb ",result);
  // Check for evaluation error (code 2001) in nested error object
  if (result?.error?.code === "2001") {
    return calculatedFields;
  }

  const loanResult = result?.loanResult ?? result?.assignedTpResult?.loanResult;

  // Early return if loanResult is missing or empty
  if (!loanResult || Object.keys(loanResult).length === 0) {
    // console.warn("Empty or missing loanResult");
    return calculatedFields;
  }

  if (!loanId) {
    // console.warn("No loan ID found in loanResult");
    return calculatedFields;
  }

  const flattenedResult = {
    loanResult: {
      loanEconomics: loanResult[loanId]?.loanEconomics || {},
      loanCharacterisations: loanResult[loanId]?.loanCharacterisations || {},
      loanFeatures: loanResult[loanId]?.loanFeatures || {},
      guideLineLimit: loanResult[loanId]?.guideLineLimit || {},
      logicTests: loanResult[loanId]?.logicTests || {}
    },
    propertiesResults: result.propertiesResults || {}
  };

  // Create a map of calculated fields
  const enrichedFields = calculatedFields.map((field: any) => {
    const value = getValueByPath(flattenedResult, field.path);
    const enrichedField = {
      ...field,
      calculatedResult: value
        ? formatValueByType(
            value.toString(),
            typeof field.type === "string" ? field.type : ""
          )
        : null
    };
    if (field.loanPropertyId) {
      // Check if the field has a loanPropertyId
      const { loanPropertyId } = field;

      // Ensure propertiesResults exists and contains the specific loanPropertyId
      if (
        flattenedResult.propertiesResults &&
        flattenedResult.propertiesResults[loanPropertyId]
      ) {
        const propertyResult =
          flattenedResult.propertiesResults[loanPropertyId];
        // Add the calculated result to the specific property based on loanPropertyId
        propertyResult[field.field] = enrichedField.calculatedResult;
        const value = resolveSmartPath(field.path, flattenedResult);
        // Optionally, update the field with the updated property (including the calculatedResult)
        enrichedField.calculatedResult =
          value !== undefined && value !== null
            ? formatValueByType(
                value.toString(),
                typeof field.type === "string" ? field.type : ""
              )
            : null;
      }
    }
    return enrichedField;
  });

  return enrichedFields;
}
function updateLoanFieldsOnRecalculate(
  loanResults: any,
  loanFields: any,
  loanId: any
) {
  const recalculatedLoanFields = loanFields.map((field: any) => {
    if (field.outputDataMadeInput) {
      const dbValue = resolvePath(field?.ttfInfoPath, loanResults, { loanId });
      return {
        ...field,
        documentInfoDB: dbValue,
        documentInfo: formatData(dbValue, field.type)
      };
    }
    return field;
  });

  return recalculatedLoanFields;
}

const failureCallback = (
  dispatch: any,
  documentReviewDispatch: any,
  message: any
) => {
  dispatch(clearLoader());
  if (documentReviewDispatch) {
    snackBarOpenAndClose(documentReviewDispatch, message);
  } else {
    snackBarOpenAndCloseReconcileView(dispatch, message);
  }
};

const submitFinalCallback = (dispatch: any, documentReviewDispatch: any) => {
  dispatch(hideLoader());
  if (documentReviewDispatch) {
    snackBarOpenAndClose(documentReviewDispatch, submittedSuccessMessage);
  } else {
    snackBarOpenAndCloseReconcileView(dispatch, submittedSuccessMessage);
  }
};

const saveFinalCallback = (dispatch: any, documentReviewDispatch: any) => {
  dispatch(clearLoader());
  if (documentReviewDispatch) {
    snackBarOpenAndClose(documentReviewDispatch, savedSuccessMessage);
  } else {
    snackBarOpenAndCloseReconcileView(dispatch, savedSuccessMessage);
  }
};

export const setBundleData = async (
  dispatch: any,
  loanId: string,
  loanStage: LoanStage,
  loanDetails: any,
  formattedPropertyData: any,
  loanType: string
) => {
  dispatch(
    getRuleEvaluationByLoanId(
      loanId,
      loanStage,
      loanDetails?.loanInfo?.takeoutPartner,
      false,
      formattedPropertyData,
      loanType,
      true
    )
  );
  dispatch(
    getOverriddenOutputValues(
      loanId,
      loanStage,
      loanDetails?.loanInfo?.takeoutPartner
    )
  ); // need this as some results might have been carry forwarded from previous stage.
  if (postApprovalStates.includes(loanDetails.loanState)) {
    let bundleDetails: any;
    try {
      bundleDetails = await getBundleLoanData(loanId, true);
    } catch (err) {
      console.error(err);
      bundleDetails = null;
      // Handle error
    }
    if (bundleDetails?.loanbundleData) {
      dispatch(setBundleLoanData(bundleDetails));
    } else if (bundleDetails?.bundleId) {
      dispatch(
        setBundleLoanData({
          loanbundleData: {
            bundleDetails: { bundleId: bundleDetails.bundleId }
          },
          calcFields: {},
          bundleStatus: bundleDetails?.bundleStatus || ""
        })
      );
    } else {
      setBlankBundleData(dispatch);
    }
    return { calcFieldsFromBundles: bundleDetails?.calcFields}
  } else {
    setBlankBundleData(dispatch);
  }
  return { calcFieldsFromBundles: {} };
};

const setBlankBundleData = (dispatch: any) => {
  dispatch(
    setBundleLoanData({
      loanbundleData: {
        bundleDetails: { bundleId: "" }
      },
      calcFields: {},
      bundleStatus: ""
    })
  );
};

export const sortByTagName = (a: any, b: any) => {
  const tagDiff = [null, undefined].includes(a?.TagsInternal?.[0]?.tag?.name)
    ? -1
    : a?.TagsInternal?.[0]?.tag?.name?.localeCompare(
        b?.TagsInternal?.[0]?.tag?.name
      );
  if (tagDiff !== 0) {
    return tagDiff;
  }

  // If the tags are equal, then objects with isPurchasePrimary=true should come first.
  const purchasePrimaryDiff = a.isPurchasePrimary - b.isPurchasePrimary;
  if (purchasePrimaryDiff !== 0) {
    return purchasePrimaryDiff * -1;
  }

  // If the tags and isPurchasePrimary are equal, then sort by name in ascending order.
  return a.name.localeCompare(b.name);
};

export const sortByLabel = (a: any, b: any) => a?.label?.localeCompare(b.label);

export const callAggregateLoanService = async (
  dispatch: any,
  loanId: string,
  loanStage: LoanStage,
  loanType: string,
  toBeSubmittedData: any,
  updateLoanCallback: any,
  changedRulesFields: any[],
  saveObj?: any
) => {
  const promiseA = getLoanInfoForTTF(loanId, loanStage);
  promiseA.then((response: any) => {
    const loanDetails = updateLoanDetailsInStore(
      dispatch,
      response.data,
      loanId,
      loanStage,
      loanType
    );
    if (
      changedRulesFields.includes("firstPaymentDateOfLoan") &&
      loanType.includes("DSCR")
    ) {
      loanDetails.loanEscrowMap = [];
      removeLoanEscrowMap(loanId);
    }
    updateLoanCallback &&
      updateLoanCallback(loanDetails, toBeSubmittedData, saveObj);
  });
};

export const callAggregatePropertyService = async (
  dispatch: any,
  loanId: string,
  loanStage: LoanStage,
  loanType: string,
  toBeSubmittedData: any,
  updatePropertyCallback: any,
  changedRulesFields: any[],
  saveObj?: any
) => {
  const promiseB = getPropertyInfoForTTF(loanId, loanStage);
  promiseB
    .then((resp: any) => {
      if (
        changedRulesFields.includes("firstPaymentDateOfLoan") &&
        loanType.includes("DSCR")
      ) {
        resp.data?.forEach((prop: any) => {
          prop.propertyEscrowMap = [];
        });
        removePropertyEscrowMap(loanId, loanStage);
      }
      const { propertyDetails } = updatePropertyDetailsInStore(
        dispatch,
        resp.data,
        loanId,
        loanStage,
        loanType
      );
      updatePropertyCallback(propertyDetails, toBeSubmittedData, saveObj);
    })
    .catch((e) => console.error(e));
};

export const addLoanAndUserLevelBaseDataInfo = (
  valueType: string,
  loanFields: any,
  userFields: any,
  baseData: any,
  page: string,
  skipFormat = false,
  loanId?: string,
  loanDetails?: any
) => {
  addLoanLevelBaseDataInfo(
    valueType,
    loanFields,
    baseData?.loans,
    skipFormat,
    page,
    loanId,
    loanDetails,
    baseData
  );
  addUserLevelBaseDataInfo(
    valueType,
    userFields,
    baseData?.loans?.loanUserMap,
    skipFormat,
    page,
    loanDetails
  );
};

export const addPropertyLevelBaseDataInfo = (
  valueType: string,
  propertyFields: any,
  propertyBaseData: any = [],
  page: string,
  skipFormat = false
) => {
  const additionalInfoKeys = ["diligenceInfo", "wellsInfo", "servicerInfo"];
  if (propertyBaseData?.length) {
    let sortedpropertyBaseData: any[];
    if (additionalInfoKeys?.includes(valueType)) {
      sortedpropertyBaseData = propertyBaseData;
    } else {
      sortedpropertyBaseData = sortByKey(
        propertyBaseData,
        "loanPropertyOrder",
        "loanPropertyId"
      );
      sortedpropertyBaseData.forEach((property: any) => {
        if (property?.propertyUnit?.length > 1) {
          property.propertyUnit = sortByKey(
            property.propertyUnit,
            "propertyUnitOrder",
            "propertyUnitId"
          );
        }
      });
    }
    propertyFields.forEach((property: any, index: number) => {
      property.forEach((field: any) => {
        const propertyIdIndex = additionalInfoKeys?.includes(valueType)
          ? index
          : sortedpropertyBaseData.findIndex(
              (item: ObjectType) => item.loanPropertyId === field.loanPropertyId
            );
        addBaseDataInfo(
          valueType,
          field,
          sortedpropertyBaseData[propertyIdIndex],
          skipFormat,
          page
        );
        if (
          additionalInfoKeys?.includes(valueType) &&
          field.field === "addressLine1"
        ) {
          const path = "propertyLocation.locationValidationStatus";
          field.locationValidationStatus = resolvePath(
            path,
            sortedpropertyBaseData[propertyIdIndex]
          );
        }
      });
    });
  }
};

export const addPropertyLevelExtractedDataInfoInitialState = (
  valueType: string,
  propertyFields: any,
  propertyBaseData: any = [],
  skipFormat: boolean
) => {
  if (propertyBaseData?.length) {
    propertyFields.forEach((property: any) => {
      property.forEach((field: any) => {
        addBaseDataInfo(
          valueType,
          field,
          propertyBaseData[0],
          skipFormat,
          "review"
        );
      });
    });
  }
};

export const addLoanLevelBaseDataInfo = (
  valueType: string,
  loanFields: any,
  baseData: any,
  skipFormat = false,
  page: string,
  loanId?: string,
  loanDetails?: any,
  baseDataParentObject?: any
) => {
  loanFields.forEach((field: any) => {
    addBaseDataInfo(
      valueType,
      field,
      baseData,
      skipFormat,
      page,
      loanId,
      loanDetails,
      baseDataParentObject
    );
  });
};

// export const addUserLevelDiligenceInfo = (
//   valueType: string,
//   userFields: any,
//   borrowerBaseData: any[] = [],
//   guarantorBaseData: any[] = [],
//   skipFormat = false
// ) => {
//   let countOfBorrowers = 0;
//   if (borrowerBaseData?.length) {
//     borrowerBaseData.forEach((user: any, index: number) => {
//       userFields.forEach((field: any) => {
//         if (field.userType === "Borrower") {
//           if (field.index === index) {
//             addBaseDataInfo(valueType, field, user, skipFormat, "reconcile");
//           }
//           countOfBorrowers = field.index + 1;
//         }
//       });
//     });
//   }
//   if (guarantorBaseData?.length) {
//     guarantorBaseData.forEach((user: any, index: number) => {
//       userFields.forEach((field: any) => {
//         if (
//           field.userType === "Guarantor" &&
//           field.index - countOfBorrowers === index
//         ) {
//           addBaseDataInfo(valueType, field, user, skipFormat, "reconcile");
//         }
//       });
//     });
//   }
// };

export const addUserLevelDiligenceInfo = (
  valueType: string,
  userFields: any,
  entitiesBaseData: any[] = [],
  personsBaseData: any[] = [],
  skipFormat = false
) => {
  let countOfBorrowers = 0;
  if (entitiesBaseData?.length) {
    entitiesBaseData.forEach((user: any, index: number) => {
      userFields.forEach((field: any) => {
        if (field.labelType === "Entity") {
          if (field.index === index) {
            addBaseDataInfo(valueType, field, user, skipFormat, "reconcile");
          }
          countOfBorrowers = field.index + 1;
        }
      });
    });
  }
  if (personsBaseData?.length) {
    personsBaseData.forEach((user: any, index: number) => {
      userFields.forEach((field: any) => {
        if (
          field.labelType === "Person" &&
          field.index - countOfBorrowers === index
        ) {
          addBaseDataInfo(valueType, field, user, skipFormat, "reconcile");
        }
      });
    });
  }
};

export const getDiscrepanciesOrFullSet = (fieldSet: any, showAll: boolean, discrepanciesFromBE: any[] = []) => {
  const newFields = fieldSet?.map((item: any) => {
    let isDiscrepancy = false;
    if (discrepanciesFromBE?.length) {
      isDiscrepancy = item?.isDiscrepancyFromBe ?? false;
    } else {
      const diligenceInfo = item?.diligenceInfo ?? null;
      let documentInfo = item?.documentInfo ?? null;
      let loanInfo = item?.loanInfo ?? null;
      const emptyValues = ["", null, 0, "0"];
      if(item?.field === "loanPurpose" && loanInfo === "Delayed Purchase") {
        loanInfo = "Cash Out"
      }
      if(item?.field === "loanPurpose" && documentInfo === "Delayed Purchase") {
        documentInfo = "Cash Out"
      }
      isDiscrepancy = !(
        (typeof loanInfo === "string" &&
          typeof diligenceInfo === "string" &&
          loanInfo.trim().toLowerCase() === diligenceInfo.trim().toLowerCase()) ||
        loanInfo == diligenceInfo ||
        (emptyValues?.includes(loanInfo) &&
          emptyValues?.includes(diligenceInfo))
      );
      if(documentInfo && diligenceInfo) {
        isDiscrepancy = !(
          (typeof documentInfo === "string" &&
            typeof diligenceInfo === "string" &&
            documentInfo.trim().toLowerCase() === diligenceInfo.trim().toLowerCase()) ||
          documentInfo == diligenceInfo ||
          (emptyValues?.includes(documentInfo) &&
            emptyValues?.includes(diligenceInfo))
        );
      }
      if(item?.field === "dscrCalculation") {
        // If loanInfo is N/A and TPR has any value other than an actual value don't show as discrepancy
        if(loanInfo === "N/A" && ["N/A", null, "", undefined, "0", 0].includes(diligenceInfo)) {
          isDiscrepancy = false;
        }
      }
      if(item?.field === "outOfPocketBudget" && isDiscrepancy) {
        // If loanInfo and TPR is empty or 0 then don't show as discrepancy
        if(!loanInfo && ["N/A", null, "", undefined, "0", 0, "0.00"].includes(diligenceInfo)) {
          isDiscrepancy = false;
        }
      }
    }
    const doesDataMatch = isDiscrepancy ? "No" : "Yes";
    return { ...item, isDiscrepancy, doesDataMatch };
  });
  if (!showAll) {
    return newFields?.filter(
      (elem: any) => elem?.field === "dscr" || elem?.isDiscrepancy
    );
  }
  return newFields;
};

export const updateLoanDetailsInStore = (
  dispatch: any,
  data: any,
  loanId: string,
  loanStage: LoanStage,
  loanType: string
) => {
  prepareObjectForTemplateMapping(
    null,
    data,
    dispatch,
    "loan",
    false,
    loanStage.toLowerCase(),
    loanId,
    loanType
  );
  const newLoanDetails = formatResponse(data);
  updateLoanDetailsInRedux(newLoanDetails, dispatch); // credit-eval reducer
  const { loanInfo, loanCredit, loanUserMap, loanDetailId } = newLoanDetails;
  const loanDetails = {
    ...newLoanDetails,
    loanUserMap,
    loanInfo: getSectionObjectForRedux(loanInfo, loanInformationFields),
    loanCredit: {
      ...getSectionObjectForRedux(loanCredit, loanCreditFields),
      truliaCrimeCheck: loanDetailId?.loanConfigId?.truliaCrime
    },
    loanConfig: loanDetailId?.loanConfigId
  };
  const formattedLoanData = formatLoanDetailsResponse(data, loanStage);
  // dispatch({
  //   type: GET_LOAN_BY_ID_SUCCESS,
  //   payload: {
  //     loan: formattedLoanData,
  //     keepTab: true
  //   }
  // });
  dispatch(
    setLoanByIdSuccess({
      loan: formattedLoanData,
      keepTab: true
    })
  );
  return loanDetails;
};

export const updatePropertyDetailsInStore = (
  dispatch: any,
  data: any,
  loanId: string,
  loanStage: LoanStage,
  loanType: string
) => {
  let propertyDetails: any = [];
  updatePropertyDetailsInRedux(data, dispatch);
  const newPropertyDetails = data.sort(
    (a: any, b: any) => a.loanPropertyOrder - b.loanPropertyOrder
  );
  if (newPropertyDetails?.length) {
    const propertyObj = newPropertyDetails.map((element: any) => {
      const {
        loanPropertyId,
        propertyinfo,
        propertyLocation,
        propertyUnit = [],
        loanPropertyOrder,
        valuations
      } = element;
      return {
        ...element,
        loanPropertyId,
        loanPropertyOrder,
        propertyInfo: getSectionObjectForRedux(
          propertyinfo,
          propertyInformationFields
        ),
        propertyLocation,
        valuations,
        propertyUnit: propertyUnit?.length
          ? propertyUnit.map((item: ObjectType) =>
              getSectionObjectForRedux(item, unitInformationFields)
            )
          : []
      };
    });
    propertyDetails = propertyObj || [];
  } else {
    propertyDetails = [];
  }
  const formattedPropertyData = formatPropertyResponse(
    data,
    loanStage,
    loanType
  );
  dispatch(
    getPropertyDetails({
      propertyDetails: formattedPropertyData,
      thirtyYearLoanPropertyDetails: formattedPropertyData,
      keepTab: true
    })
  );
  if (data.length) {
    prepareObjectForTemplateMapping(
      null,
      data[0],
      dispatch,
      "property",
      false,
      loanStage.toLowerCase(),
      loanId,
      loanType
    );
  }
  return {
    propertyDetails,
    formattedPropertyData
  };
};

export const cleanObject = (object: any) => {
  Object.entries(object).forEach((item: any) => {
    const [k, v] = item;
    if (v && typeof v === "object") {
      cleanObject(v);
    }
    if (
      (v &&
        typeof v === "object" &&
        !(v instanceof Date) &&
        !Object.keys(v).length) ||
      v === null ||
      v === undefined ||
      v?.length === 0
    ) {
      if (Array.isArray(object)) {
        object.splice(k, 1);
      } else {
        delete object[k];
      }
    }
  });
  return object;
};

export const objectFlip = (obj: ObjectType) => {
  const ret: any = {};
  Object.keys(obj).forEach((key: string) => {
    ret[obj[key]] = key;
  });
  return ret;
};

const getLoanPayLoadData = (
  loanRuleVersions: ObjectType,
  loanSummaryTTF: ObjectType,
  loanFeesTTF: ObjectType,
  achDataTTF: ObjectType,
  isDSCR: boolean,
  bridgeLoanBorrowerInformationTTF: ObjectType,
  bridgeLoanGuarantorInformationTTF: ObjectType,
  thirtyYearLoanInformationTTF: ObjectType,
  thirtyYearLoanEconomicsTTF: ObjectType,
  bridgeLoanInformationTTF: ObjectType,
  bridgeLoanEconomicsTTF: ObjectType,
  bridgeLoanDetailIdTTF: ObjectType,
  thirtyYearLoanDetailIdTTF: ObjectType
) => {
  const data = {
    borrowerInformation: bridgeLoanBorrowerInformationTTF,
    guarantorInformation: bridgeLoanGuarantorInformationTTF,
    loanInformation: null,
    loanEconomics: null,
    loanRuleVersions,
    loanSummary: loanSummaryTTF,
    loanFees: loanFeesTTF,
    achData: achDataTTF,
    loanDetailId: null
  };
  if (isDSCR) {
    data.loanInformation = thirtyYearLoanInformationTTF.payload;
    data.loanEconomics = thirtyYearLoanEconomicsTTF.payload;
    data.loanDetailId = thirtyYearLoanDetailIdTTF.payload;
  } else {
    data.loanInformation = bridgeLoanInformationTTF?.payload;
    data.loanEconomics = bridgeLoanEconomicsTTF?.payload;
    data.loanDetailId = bridgeLoanDetailIdTTF?.payload;
  }

  return data;
};

export const prepareUserFieldsForRedux = (
  loanDetails: any,
  userDetails: any = [],
  isDSCR: boolean,
  editHistory: any,
  page: string,
  isDataReconSyncFlowEnabled?: boolean
) => {
  let userFields: any[] = [];
  let borrowerData: any = [];
  let guarantorData: any = [];
  let counter = 0;
  userDetails.forEach((user: any) => {
    const extensibleUser = JSON.parse(JSON.stringify(user));
    user?.loanUserType !== "Guarantor"
      ? borrowerData.push(extensibleUser)
      : guarantorData.push(extensibleUser);
  });
  // console.log("userDetails", { borrowerData, guarantorData });
  if (borrowerData.length > 1) {
    borrowerData = sortUserData(borrowerData, page);
  }
  if (guarantorData.length > 1) {
    guarantorData = sortUserData(guarantorData, page);
  }
  borrowerData.forEach((user: any) => {
    user.index = counter;
    counter++;
  });
  guarantorData.forEach((user: any) => {
    user.index = counter;
    counter++;
  });
  if(page === "review") {
    userFields = [
      ...prepareUserArray(
        borrowerData,
        "Borrower",
        isDSCR,
        editHistory,
        loanDetails,
        page,
        isDataReconSyncFlowEnabled
      ),
      ...prepareUserArray(
        guarantorData,
        "Guarantor",
        isDSCR,
        editHistory,
        loanDetails,
        page,
        isDataReconSyncFlowEnabled
      )
    ];
  } else {
    let entitiesData: any = [];
    let personsData: any = [];
    let borrowerPersonData: any = [];
    let guarantorPersonData: any = [];
    let counter2 = 0;
    userDetails.forEach((user: any) => {
      const extensibleUser = JSON.parse(JSON.stringify(user));
      user?.customer?.partyType === "account"
        ? entitiesData.push(extensibleUser)
        : user?.loanUserType !== "Guarantor"
          ? borrowerPersonData.push(extensibleUser)
          : guarantorPersonData.push(extensibleUser)
        // : personsData.push(extensibleUser);
    });
    entitiesData = sortUserData(entitiesData);
    entitiesData.forEach((user: any) => {
      user.index = counter2;
      counter2++;
    });
    borrowerPersonData = sortUserData(borrowerPersonData, page);
    guarantorPersonData = sortUserData(guarantorPersonData, page);
    borrowerPersonData.forEach((user: any) => {
      user.index = counter2;
      counter2++;
    });
    guarantorPersonData.forEach((user: any) => {
      user.index = counter2;
      counter2++;
    });
    personsData = [ ...borrowerPersonData, ...guarantorPersonData];
    userFields = [
      ...prepareUserArrayforDataRecon(
        entitiesData,
        "Entity",
        isDSCR,
        editHistory,
        loanDetails,
        page,
        isDataReconSyncFlowEnabled
      ),
      ...prepareUserArrayforDataRecon(
        personsData,
        "Person",
        isDSCR,
        editHistory,
        loanDetails,
        page,
        isDataReconSyncFlowEnabled
      )
    ];
  }

  return userFields;
};

export const prepareCalculatedFieldsForReduxDataRecon = (
  loanDetails: any,
  isDSCR: boolean,
  diligenceInfo: any,
  submittedDocumentInfo: any,
  view: string,
  wellsInfo?: any,
  servicerInfo?: any
) => {
  let calculatedFields: any = [];
  let fieldSet: any = isDSCR
    ? DSCRDataReconCalculatedFields
    : BridgeDataReconCalculatedFields;
  fieldSet = fieldSet.filter(
    (field: any) =>
      !(
        typeof field.hidden === "function" &&
        field.hidden(loanDetails, "reconcile")
      )
  );
  fieldSet = fieldSet?.filter((obj: any) => ASFSheetCalculatedFields?.includes(obj?.field))


  const { loanDetailId, loanResults, calcFieldsFromBundles } = loanDetails ?? {};
  const loanId = loanDetailId?.loanId;

  const keyNames =
    view === "tc-reconcile-view"
      ? ["diligenceInfo", "loanInfo", "wellsInfo", "servicerInfo"]
      : ["diligenceInfo", "loanInfo", "ttfInfo"];

  fieldSet.forEach((element: any) => {
    let obj: any = {};
    const flattenedPath = element?.path
      ? element?.path
          ?.replace("loanResults", "results")
          .replace("[loanId]", `${loanDetails?.loanDetailId?.loanId}`)
      : "";
    const fieldFlattenedKey = `data.${flattenedPath}`;
    obj = {
      label: element?.label,
      field: element?.field,
      rulesKey: element?.rulesKey,
      originalLoanInfo: "",
      loanInfo: "",
      ttfInfo: "",
      diligenceInfo: "",
      documentInfo: "",
      doesDataMatch: "No",
      path: element?.path,
      type: element?.type,
      formulaText: element?.formulaText,
      formulaVariables: element?.formulaVariables,
      fieldFlattenedKey,
      tprInfoPath: getCalculatedFieldTprInfoPath(element?.path, loanId)
    };
    calculatedFields.push(obj);
  });

  keyNames?.forEach((key: string) => {
    let loanResult = null;
    switch (key) {
      case "loanInfo": {
        let loanResultsData: any = loanDetails?.loanResults ?? {};
        const calcLoanResults = calcFieldsFromBundles?.loanResults?.[loanId];
        loanResultsData = mergeLoanResults(loanResultsData, calcLoanResults, loanId);
        loanResult = loanResultsData;
        break;
      }
      case "diligenceInfo":
        let diligenceInfoLoanResultsData = diligenceInfo?.results ?? {};
        const calcDiligenceResultsFromBundles = diligenceInfo?.results?.loanResults?.[loanId];
        diligenceInfoLoanResultsData = mergeLoanResults(diligenceInfoLoanResultsData, calcDiligenceResultsFromBundles, loanId);
        loanResult = diligenceInfoLoanResultsData;
        break;
      case "ttfInfo": {
        let ttfInfoLoanResultsData = submittedDocumentInfo?.results ?? {};
        const calcResultsFromBundles = submittedDocumentInfo?.results?.loanResults?.[loanId];
        ttfInfoLoanResultsData = mergeLoanResults(ttfInfoLoanResultsData, calcResultsFromBundles, loanId);
        loanResult = ttfInfoLoanResultsData;
        break;
      }
      case "wellsInfo":
        loanResult = wellsInfo?.result?.loanResult;
        break;
      case "servicerInfo":
        loanResult = servicerInfo?.result?.loanResult;
        break;
      default:
        break;
    }
    calculatedFields = getValueWRTKey(
      calculatedFields,
      key,
      loanResult,
      loanId
    );
  });
  // calculatedFields = getCurrentInfoData(calculatedFields, loanResultData);
  calculatedFields = calculatedFields?.map((item: any) => {
    if(item?.field === "totalOriginationAndDiscountPointsCurrency") {
      const parseCurrencyValue = (amount: any) => {
        if (amount === null || amount === undefined || amount === "") {
          return 0;
        }
        if (typeof amount === "number") {
          return Number.isFinite(amount) ? amount : 0;
        }
        return Number(cleanCurrency(String(amount))) || 0;
      }
      const loanOriginationFeeHUD = loanDetails?.loanFees?.originationFeeHUD
      const loanDiscountPointAmount = loanDetails?.loanDetailId?.discountPointAmount
      const docOriginationFeeHUD = submittedDocumentInfo?.loans?.loanFees?.originationFeeHUD
      const docDiscountPointAmount = submittedDocumentInfo?.loans?.loanDetailId?.discountPointAmount
      const hasLoanInfo = item?.loanInfo !== undefined && item?.loanInfo !== null && item?.loanInfo !== ""
      const hasLoanInfoDB = item?.loanInfoDB !== undefined && item?.loanInfoDB !== null && item?.loanInfoDB !== ""
      const hasTtfInfo = item?.ttfInfo !== undefined && item?.ttfInfo !== null && item?.ttfInfo !== ""
      const hasTtfInfoDB = item?.ttfInfoDB !== undefined && item?.ttfInfoDB !== null && item?.ttfInfoDB !== ""
      const loanInfoFallbackValue = parseCurrencyValue(loanOriginationFeeHUD) +
        parseCurrencyValue(loanDiscountPointAmount)
      const ttfFallbackValue = parseCurrencyValue(docOriginationFeeHUD) +
        parseCurrencyValue(docDiscountPointAmount)
      return {
        ...item,
        loanInfo: !(hasLoanInfo || hasLoanInfoDB) ? formatData(loanInfoFallbackValue?.toString(), "currency") : item?.loanInfo,
        loanInfoDB: !(hasLoanInfo || hasLoanInfoDB) ? loanInfoFallbackValue : item?.loanInfoDB,
        ttfInfo: !(hasTtfInfo || hasTtfInfoDB) ? formatData(ttfFallbackValue?.toString(), "currency") : item?.ttfInfo,
        ttfInfoDB: !(hasTtfInfo || hasTtfInfoDB) ? ttfFallbackValue : item?.ttfInfoDB
      }
    } else if(["sumOfPurchasePrice", "sumOfCostBasis"].includes(item?.field)) {
      const loanInfoValue = getAggregateValue(loanDetails?.propertyDetails, "propertyEconomics", item?.field === "sumOfPurchasePrice" ? "purchasePrice" : "costBasis")
      const ttfInfoValue = getAggregateValue(submittedDocumentInfo?.properties, "propertyEconomics", item?.field === "sumOfPurchasePrice" ? "purchasePrice" : "costBasis");
      const diligenceInfoValue = item?.field === "sumOfPurchasePrice" ? diligenceInfo?.loans?.loanEconomics?.sumOfPurchasePrice : diligenceInfo?.loans?.loanEconomics?.sumOfCostBasis
      return {
        ...item,
        loanInfo: formatData(loanInfoValue?.toString(), "currency"),
        loanInfoDB: loanInfoValue,
        ttfInfo: formatData(ttfInfoValue?.toString(), "currency"),
        ttfInfoDB: ttfInfoValue,
        diligenceInfo: formatData(diligenceInfoValue?.toString(), "currency"),
        diligenceInfoDB: diligenceInfoValue,
        tprInfoPath:
          item?.field === "sumOfPurchasePrice"
            ? "data.loans.loanEconomics.sumOfPurchasePrice"
            : "data.loans.loanEconomics.sumOfCostBasis"
      }
    } else if(item?.field === "underwrittenNoiorNof") {
      const loanInfoValue = getAggregateValue(loanDetails?.loanResults?.propertiesResults, "multiFamilyMixedUse", "underwrittenNoiorNof")
      const ttfInfoValue = getAggregateValue(submittedDocumentInfo?.results?.propertiesResults, "multiFamilyMixedUse", "underwrittenNoiorNof");
      const diligenceInfoValue = getAggregateValue(diligenceInfo?.results?.propertiesResults, "multiFamilyMixedUse", "underwrittenNoiorNof")
      return {
        ...item,
        loanInfo:  loanInfoValue < 0 ? `- ${formatData(Math.abs(loanInfoValue)?.toString(), "currency")}` : formatData(loanInfoValue?.toString(), "currency"),
        loanInfoDB: loanInfoValue,
        ttfInfo: ttfInfoValue < 0 ? `- ${formatData(Math.abs(ttfInfoValue)?.toString(), "currency")}` : formatData(ttfInfoValue?.toString(), "currency"),
        ttfInfoDB: ttfInfoValue,
        diligenceInfo: diligenceInfoValue < 0 ? `- ${formatData(Math.abs(diligenceInfoValue)?.toString(), "currency")}` : formatData(diligenceInfoValue?.toString(), "currency"),
        diligenceInfoDB: diligenceInfoValue,
        tprInfoPath: "data.results.propertiesResults.[*].multiFamilyMixedUse.underwrittenNoiorNof"
      }
    } else if(item?.field === "ioTerm") {
      const loanResultData = loanDetails?.loanResults?.loanResult?.[loanId] || {};
      const submittedDocumentResultData = submittedDocumentInfo?.results?.loanResult?.[loanId] || {};
      const loanInfoValue = loanResultData?.loanFeatures?.originalTermToMaturity
      const ttfInfoValue = submittedDocumentResultData?.loanFeatures?.originalTermToMaturity
      return {
        ...item,
        loanInfo:  loanInfoValue,
        loanInfoDB:  loanInfoValue,
        ttfInfo: ttfInfoValue ,
        ttfInfoDB: ttfInfoValue,
      }
    } else if(item?.field === "rehabType") {
      const loanResultData = loanDetails?.loanResults?.loanResult?.[loanId] || {};
      const submittedDocumentResultData = submittedDocumentInfo?.results?.loanResult?.[loanId] || {};
      const loanInfoValue = loanResultData?.loanCharacterisations?.rehabType ? loanResultData?.loanCharacterisations?.rehabType :  loanResultData?.loanCharacterisations?.stabilizedFlag === "Stabilized" ? "Stabilized Bridge" : ""
      const ttfInfoValue = submittedDocumentResultData?.loanCharacterisations?.rehabType ? submittedDocumentResultData?.loanCharacterisations?.rehabType : submittedDocumentResultData?.loanCharacterisations?.stabilizedFlag === "Stabilized" ? "Stabilized Bridge" : ""
      return {
        ...item,
        loanInfo:  loanInfoValue,
        loanInfoDB:  loanInfoValue,
        ttfInfo: ttfInfoValue ,
        ttfInfoDB: ttfInfoValue,
      }
    } else {
      return { ...item }
    }
  })
  return calculatedFields;
};

export const getValueWRTKey = (
  calculatedFields: any,
  key: string,
  loanResultData: any,
  loanId?: string
) => {
  const obj: any = { loanResults: loanResultData };
  let notAvailableKey = false;
  const notAvailableValue = "-";
  return calculatedFields.map((field: any) => {
    let path = field?.path;
    if (field?.path?.includes("[loanId]")) {
      path = path?.replace("[loanId]", `${loanId}`);
    }
    let value = getValueByPath(obj, path);
    if(["wellsInfo", "servicerInfo"].includes(key)) {
      notAvailableKey = !hasPath(path, obj);
      value = notAvailableKey ? notAvailableValue : value;
    }
    return {
      ...field,
      ...(key === "diligenceInfo"
        ? { tprInfoPath: getCalculatedFieldTprInfoPath(path, loanId) }
        : {}),
      [key]: notAvailableKey ? notAvailableValue : value ? formatData(`${value}`, field.type) : ""
    };
  });
};

const getAggregateValue = (properties: any, objName: string, keyName: string) => {
  let values = 0;
  const parseToNumber = (input: any) => {
    if (typeof input === "number") {
      return Number.isFinite(input) ? input : 0;
    }

    if (typeof input !== "string") {
      return 0;
    }

    const trimmed = input.trim();
    if (!trimmed) {
      return 0;
    }

    const isNegativeByParens = /^\(.*\)$/.test(trimmed);
    const sanitized = trimmed.replace(/[,$\s()]/g, "");
    const normalized = isNegativeByParens ? `-${sanitized}` : sanitized;
    const parsed = Number(normalized);

    return Number.isFinite(parsed) ? parsed : 0;
  };

  // Convert object to array if properties is an object
  const propertiesArray = typeof properties === 'object' && !Array.isArray(properties) 
    ? Object.values(properties) 
    : properties;
  
  propertiesArray?.forEach((property: any) => {
    const obj = property?.[objName];  
    if(obj) { 
      const value = obj?.[keyName];     
      if(typeof value === "string" || typeof value === "number") {
        values = values + parseToNumber(value);
      }
    }
  });
  return values;  

}

const getCurrentInfoData = (calculatedFields: any, loanResultData: any) => {
  const obj: any = { loanResult: loanResultData };
  return calculatedFields.map((field: any) => {
    const value = getValueByPath(obj, field?.path);
    return {
      ...field,
      loanInfo: formatValueByType(value, field.type)
    };
  });
};

const addBaseDataInfo = (
  valueType: string,
  field: any,
  baseObj: any,
  skipFormat: boolean,
  page: string,
  loanId?: string,
  loanDetails?: any,
  baseDataParentObject?: any
) => {
  let dbValue: any = "";
  let notAvailableKey = false;
  const notAvailableValue = "-"

  if (field.path !== "") {
    if (
      page === "review" &&
      valueType === "documentInfo" &&
      fieldsTobeCalculatedOnInitialLoad(field.field) &&
      loanDetails
    ) {
      dbValue = calculateFieldTobeCalculatedOnInitialLoad(
        field,
        baseObj,
        loanDetails
      );
    } else if (isCreditEventField(field.field) && loanDetails) {
      dbValue = calculateLastFcSsDilBkMonths(field, baseObj, loanDetails);
    } else if (isCreditBureau(field.field)) {
      dbValue = resolveSmartPath(field.path, baseObj);
    } else if (isValuationField(field.field)) {
      if (valueType === "extractedInfo") {
        dbValue = resolveSmartPath(field?.extractedInfoPath, baseObj);
      } else
        dbValue = resolveValuationPath(field.path, baseObj, page, valueType);
    } else if (
      field.outputDataMadeInput &&
      valueType === "documentInfo" &&
      page !== "reconcile"
    ) {
      dbValue = resolvePath(field?.ttfInfoPath, baseDataParentObject, {
        loanId
      });
    } else {
      dbValue = resolvePath(field.path, baseObj, { loanId });
    }
  }

  if (field?.type?.startsWith("date") && valueType === "diligenceInfo") {
    dbValue = dbValue?.replace(" ", "T");
  }
  if (
    page === "review" &&
    valueType === "documentInfo" &&
    field.field === "downPaymentReserve" &&
    dbValue === null &&
    loanDetails?.originatorInfo?.accountName !== "Merchants"
  ) {
    dbValue = "0.00"; // Default value for downPaymentReserve for non-Merchants
  }
  if(page === "reconcile" && ["wellsInfo", "servicerInfo"].includes(valueType)) {
    notAvailableKey = !hasPath(field.path, baseObj);
    dbValue = notAvailableKey ? notAvailableValue : dbValue;
  }
  field[`${valueType}DB`] = dbValue;
  field.originalValue = dbValue;
  if (skipFormat) {
    if (valueType === "extractedInfo" && field.extractedInfoDB?.length === 1) {
      field.temporaryDocInfoDB = field.extractedInfoDB[0].editedValue;
      field.temporaryDocInfo = formatData(
        field.extractedInfoDB[0].editedValue,
        field.type
      );
      if ([null, ""].includes(field.documentInfo)) {
        field.status = "";
        field.extractedInfoDB = JSON.parse(
          JSON.stringify(field.extractedInfoDB)
        );
        field.extractedInfoDB[0].selected = true;
      } else if (field.documentInfo === field.temporaryDocInfo) {
        field.status = "APPROVED";
      } else {
        field.status = "REJECTED";
      }
    }
  } else {
    let formattedValue = formatData(field[`${valueType}DB`], field.type)
    
    // if (
    //   valueType === "documentInfo" &&
    //   field.field === "totalOriginationAndDiscountPoints" &&
    //   dbValue === field?.loanInfoDB
    // ) {
    //   formattedValue = field?.loanInfo ?? formattedValue;
    // }

    field[valueType] = notAvailableKey ? notAvailableValue : formattedValue;
    if(field?.isMultiplyBy100) {
      field[valueType] = dbValue !== null && dbValue !== undefined ? (Number(dbValue) * 100).toFixed(4) : formattedValue
    }
    field = transformInfo(field, field, valueType, page);
  }
};

const addMappings = (
  field: any,
  index: number,
  dataPoints: any[] | null,
  section: "Loan" | "Property" | "User",
  tagList: any[]
) => {
  field.posIndex = index;
  if (field.unitIndex !== undefined) {
    section += "Unit";
  }
  if (dataPoints?.length) {
    const dataPoint = dataPoints.find((item) => {
      const isCreditBureauField = [
        "Equifax",
        "TransUnion",
        "Experian"
      ].includes(field.field);
      const targetName = isCreditBureauField ? "creditScore" : field.field;
      return item.name === targetName && section === item.section;
    });
    field.categories = dataPoint?.categories || [];
    field.categoriesNamesList = dataPoint?.categoriesNamesList || [];
    field.documents = dataPoint?.documents || [];
    field.documentTagNames = tagList
      .filter((tag: any) => field.documents.includes(tag?.code))
      .map((tag: any) => tag.name);
  }
};

export const addUserLevelExtractedDataInfoInitialState = (
  valueType: string,
  userFields: any,
  userBaseData: any,
  skipFormat: boolean
) => {
  if (userBaseData?.length) {
    userBaseData.forEach((user: any) => {
      userFields.forEach((field: any) => {
        if (field.userType === user.loanUserType) {
          addBaseDataInfo(valueType, field, user, skipFormat, "review");
        }
      });
    });
  }
};

const processUserFields = (
  userMap: ObjectType[],
  field: ObjectType,
  valueType: string,
  primaryKey: string,
  secondaryKey: string,
  tertiaryKey: string,
  skipFormat: boolean,
  loanDetails: any,
  page: string
) => {
  let index = setUserBaseData(
    userMap,
    field,
    valueType,
    primaryKey,
    skipFormat,
    loanDetails,
    page
  );
  if (index === -1) {
    index = setUserBaseData(
      userMap,
      field,
      valueType,
      secondaryKey,
      skipFormat,
      loanDetails,
      page
    );
  }
  if (index === -1) {
    setUserBaseData(
      userMap,
      field,
      valueType,
      tertiaryKey,
      skipFormat,
      loanDetails,
      page
    );
  }
};

export const addUserLevelBaseDataInfo = (
  valueType: string,
  userFields: ObjectType[],
  userBaseData: ObjectType[],
  skipFormat: boolean,
  page: string,
  loanDetails?: any
) => {
  let userMaps: any = {};
  let entitiesUserMap: any = [];
  let personsUserMap: any = [];
  let borrowerPersonData: any = [];
  let guarantorPersonData: any = [];

  if (userBaseData?.length) {
    let borrowerUserMap: any = [];
    let guarantorUserMap: any = [];
    userBaseData.forEach((user: any) => {
      if(page !== "review") {
        if(user?.customer?.partyType === "account") {
          entitiesUserMap.push(user);
        } else {
          if(user?.loanUserType !== "Guarantor") {
            borrowerPersonData.push(user);
          } else {            
            guarantorPersonData.push(user);
          }
          // personsUserMap.push(user);
        }
        borrowerPersonData = sortUserData(borrowerPersonData);
        guarantorPersonData = sortUserData(guarantorPersonData);
        personsUserMap = [ ...borrowerPersonData, ...guarantorPersonData];
        userMaps = {
          Entity: entitiesUserMap,
          Person: personsUserMap
        };
      } else {
        if (user.loanUserType !== "Guarantor") {
        borrowerUserMap.push(user);
        } else {
          guarantorUserMap.push(user);
        }
        if (borrowerUserMap.length > 1) {
          borrowerUserMap = sortUserData(borrowerUserMap);
        }
        if (guarantorUserMap.length > 1) {
          guarantorUserMap = sortUserData(guarantorUserMap);
        }
        userMaps = {
          Borrower: borrowerUserMap,
          Guarantor: guarantorUserMap
        };
        
        userFields.forEach((field: ObjectType) => {
          const { labelType, userType } = field;
          const userMap = userMaps[labelType] ?? userMaps[userType];
          processUserFields(
            userMap,
            field,
            valueType,
            "partyId",
            "loanUserSequence",
            "loanUserMapId",
            skipFormat,
            loanDetails,
            page
          );
        });
      }
      
    });

    // ADDING FOR DATA RECON PAGE AS ENTITY AND PERSON ARE LABEL TYPES 
    if(page !== "review") {
      userFields.forEach((field: ObjectType) => {
        const { labelType, userType } = field;
        const userMap = userMaps[labelType] ?? userMaps[userType];
         if (userMap) {  
          processUserFields(
            userMap,
            field,
            valueType,
            "partyId",
            "loanUserSequence",
            "loanUserMapId",
            skipFormat,
            loanDetails,
            page
          );
        }
      });
    }
    
  }
};

const transformInfo = (obj: any, element: any, key: string, page?: string) => {
  // SFR in BE is shown as Single Family Detached on UI. To remove this and handle from BE later.
  if (obj[`${key}DB`] === "SFR" && element?.field === "propertyType") {
    obj[key] = "Single Family Detached";
  }
  if (
    !obj?.documentInfo &&
    obj?.loanInfo === obj?.diligenceInfo &&
    page === "reconcile"
  ) {
    obj.documentInfo = obj?.loanInfo;
    obj.documentInfoDB = obj?.loanInfoDB;
  }
  if (monthlyFields?.includes(element?.field)) {
    const toMonthly = (value?: string) =>
      value
        ? (Number(cleanCurrency(value)) / 12).toFixed(2)
        : value;

    obj.loanInfo = formatData(toMonthly(obj?.loanInfoDB), element?.type);
    obj.documentInfo = formatData(toMonthly(obj?.documentInfoDB), element?.type);
  }

  return obj;
};

const prepareObj = (
  obj: any,
  element: any,
  parent: any,
  toorakProduct: string,
  editHistory: any,
  createdOn?: string,
  loanId?: string,
  page?: string
) => {
  obj.loanInfoDB =
    element?.path !== "" ? resolvePath(element?.path, parent, { loanId }) : "";
  if (element?.field === "addressLine1" && obj?.loanPropertyId != null) {
    obj.locationValidationStatus = resolvePath(
      "propertyLocation.locationValidationStatus",
      parent
    );
  }
  if (element?.outputDataMadeInput) {
    obj.ttfInfoPath = element?.ttfInfoPath;
    obj.outputDataMadeInput = element?.outputDataMadeInput;
  }
  obj.loanInfo = formatData(obj.loanInfoDB, element?.type);
  if(element?.isMultiplyBy100) {
      obj.loanInfo = obj.loanInfoDB !== null && obj.loanInfoDB !== undefined ? (Number(obj.loanInfoDB) * 100).toFixed(4) : obj.loanInfo
      obj.isMultiplyBy100 = element?.isMultiplyBy100
    }
  obj.label = element?.label;
  if(element?.isReadOnlyField) {
    obj.isReadOnlyField = element?.isReadOnlyField
  }
  obj.comment = defaultComment.updatedThroughTTF;
  obj = transformInfo(obj, element, "loanInfo", page);
  return initializeObj(obj, element, toorakProduct, editHistory, createdOn);
};

const transformDropDown = (
  toorakProduct: string,
  createdOn: any,
  element: any
) => {
  const isLatestVersion =
    createdOn &&
    moment(latestVersioningDate, "DD-MM-YYYY").isSameOrBefore(
      moment(createdOn, "YYYY-MM-DD")
    );
  if (element?.field === "condoEligibility") {
    element.values = isLatestVersion
      ? condoEligibilityV2DropDown
      : condoEligibilityDropDown;
  } else if (toorakProduct === ToorakProductEnum.Rental) {
    if (element?.field === "loanStructure") {
      element.values = [LoanStructureTypes.singleDraw];
    } else if (element?.field === "propertyType") {
      element.values = element?.values.filter(
        (val: string) => !["5+ Unit Multifamily", "Mixed Use"].includes(val)
      );
    }
  }
};

const initializeObj = (
  obj: any,
  element: any,
  toorakProduct: any,
  editHistory: any,
  createdOn?: string
) => {
  obj.path = element?.path;

  obj.auditPath = element?.auditPath || element?.path;
  if (
    element?.field === "TransUnion" ||
    element?.field === "Equifax" ||
    element?.field === "Experian"
  ) {
    if (
      obj.creditInfoId !== undefined &&
      obj.auditPath?.includes("[creditInfoId]")
    ) {
      const replacement =
        obj.creditInfoId != null
          ? obj.creditInfoId.toString()
          : `creditFirm_${element?.field}`;
      obj.auditPath = obj.auditPath.replace("creditInfoId", replacement);
    }
  }

  if (element?.aliasKey !== undefined) {
    obj.aliasKey = element?.aliasKey;
  }
  if (element?.rulesKey !== undefined) {
    obj.rulesKey = element?.rulesKey;
  }
  if (element?.values !== undefined) {
    transformDropDown(toorakProduct, createdOn, element);
    obj.values = element?.values;
  }
  obj.type = element?.type;
  obj.documentInfo = "";
  obj.documentInfoDB = "";
  obj.categories = [];
  obj.documents = [];
  obj.skipRules = element?.skipRules;
  obj.field = element?.field;
  obj.disableAfterApproved = element?.disableAfterApproved;
  obj.outputDataMadeInput = element?.outputDataMadeInput;
  obj.auditHistory = editHistory?.[getFieldName(obj)];
  return obj;
};

const sortUserData = (users: any, page?: string) => {
  users.sort((a: any, b: any) => {
    if (a.isPrimary !== b.isPrimary) {
      if (a.isPrimary) {
        return -1;
      }
      return 1;
    }
    if (page !== "review" && Number(a?.originalCreditScoreMedian) !== Number(b?.originalCreditScoreMedian)) {
      return Number(b?.originalCreditScoreMedian) - Number(a?.originalCreditScoreMedian);
    }
    if (Number(a?.loanUserSequence) !== Number(b?.loanUserSequence)) {
      return Number(a?.loanUserSequence) - Number(b?.loanUserSequence);
    }
    return Number(a?.loanUserMapId) - Number(b?.loanUserMapId);
  });
  return users;
};

export const filterUsersForSomeSpecificFields = (fieldSet: any[]) => {
  if (!Array.isArray(fieldSet) || !fieldSet.length) {
    return fieldSet;
  }

  const firstPersonOnlyFields = new Set([
    "ficoModelUsed",
    "qualificationMethod"
  ]);

  return fieldSet.filter((field: any) => {
    if (!firstPersonOnlyFields.has(field?.field)) {
      return true;
    }

    const label = String(field?.label || "");
    const labelMatch = label.match(/(?:Person|Borrower|Guarantor)\s+(\d+)/i);
    if (labelMatch?.[1]) {
      return Number(labelMatch[1]) === 1;
    }

    const sequence = Number(field?.loanUserSequence);
    if (!Number.isNaN(sequence) && sequence > 0) {
      return sequence === 1;
    }

    return true;
  });
};

const prepareUserArray = (
  userData: any[],
  type: string,
  isDSCR: boolean,
  editHistory: any,
  loanDetails: any,
  page: string,
  isDataReconSyncFlowEnabled?: boolean
) => {
  const userFields: any[] = [];
  if (userData?.length) {
    let fieldSet: any = isDSCR ? DSCRUserFields : BridgeUserFields;
    if (page === "reconcile" && isDataReconSyncFlowEnabled) {
      fieldSet = [...fieldSet, ...NewDataReconUserFields];
      fieldSet = removeDuplicateFields(fieldSet, ASFSheetUserFields)
    }
    fieldSet = fieldSet.filter(
      (field: any) => !field.hidden || !field.hidden(loanDetails, page)
    );
    const creditBureauFields = ["Equifax", "Experian", "TransUnion"];
    userData.forEach((user: any, index: number) => {
      fieldSet.forEach((element: any) => {
        const obj: any = {};
        if (creditBureauFields.includes(element?.field)) {
          obj.loanInfoDB = resolveSmartPath(element?.path, user);
        } else {
          obj.loanInfoDB =
            element?.field === "isHardPull"
              ? resolvePath(element?.path, user)
                ? "Yes"
                : "No"
              : resolvePath(element?.path, user);
        }
        obj.loanInfo = formatData(obj.loanInfoDB, element?.type);
        if (
          (element?.partyType === user.customer.partyType ||
            element?.partyType === undefined) &&
          ((type === "Guarantor" && element?.guarantorAliasKey !== undefined) ||
            (type === "Borrower" && element?.borrowerAliasKey !== undefined))
        ) {
          if (element?.field === "ssNumber" || element?.field === "eiNumber") {
            obj.encryptionId =
              element?.field === "ssNumber"
                ? resolvePath("customer.ssnEncryptionId", user)
                : resolvePath("customer.einEncryptionId", user); // adjust path if needed
            obj.isEncryptedValueFetched = false; // adjust path if needed
          }
          if (creditBureauFields.includes(element?.field)) {
            obj.creditInfoId = getCreditInfoId(element?.field, userData);
          }
          obj.partyType = user?.customer?.partyType;
          obj.userType = type;
          obj.index = user.index;
          obj.aliasKey =
            type === "Borrower"
              ? element?.borrowerAliasKey
              : element?.guarantorAliasKey;
          obj.identifier =
            element?.ddIdentifier !== undefined
              ? element?.ddIdentifier
              : element?.borrowerAliasKey;
          obj.label = element?.customLabel
            ? `${type} ${index + 1} ${element?.label} Credit Score`
            : `${type} ${index + 1} ${element?.label}`;
          obj.loanUserMapId = user.loanUserMapId;
          obj.loanUserSequence = user.loanUserSequence;
          obj.partyId = user?.customer?.partyId;
          obj.isPrimary = user.isPrimary;
          obj.comment = defaultComment.updatedThroughTTF;
          obj.fieldFlattenedKey = `data.loans.loanUserMap.${
            user?.index ? Number(user?.index) : 0
          }.${element?.path}`;
          obj.tprInfoPath = `data.loans.loanUserMap.${
            user?.index ? Number(user?.index) : 0
          }.${element?.path}`;
          initializeObj(obj, element, null, editHistory);
          if(element?.hideClearIcon) {
            obj.hideClearIcon = element?.hideClearIcon?.()
          }
          userFields.push(obj);
        }
      });
    });
  }
  return userFields;
};

const prepareUserArrayforDataRecon = (
  userData: any[],
  type: string,
  isDSCR: boolean,
  editHistory: any,
  loanDetails: any,
  page: string,
  isDataReconSyncFlowEnabled?: boolean
) => {
  const userFields: any[] = [];
  if (userData?.length) {
    let fieldSet: any = isDSCR ? DSCRUserFields : BridgeUserFields;
    if (page === "reconcile" && isDataReconSyncFlowEnabled) {
      fieldSet = [...fieldSet, ...NewDataReconUserFields];
      fieldSet = removeDuplicateFields(fieldSet, ASFSheetUserFields)
    }
    fieldSet = fieldSet.filter(
      (field: any) => !field.hidden || !field.hidden(loanDetails, page)
    );
    const creditBureauFields = ["Equifax", "Experian", "TransUnion"];
    userData.forEach((user: any, index: number) => {
      fieldSet.forEach((element: any) => {
        const obj: any = {};
        const label = user?.customer?.partyType === "account" ? "Entity" : "Person"
        if (creditBureauFields.includes(element?.field)) {
          obj.loanInfoDB = resolveSmartPath(element?.path, user);
        } else {
          obj.loanInfoDB =
            element?.field === "isHardPull"
              ? resolvePath(element?.path, user)
                ? "Yes"
                : "No"
              : resolvePath(element?.path, user);
        }
        obj.loanInfo = formatData(obj.loanInfoDB, element?.type);
        if (
          (element?.partyType === user.customer.partyType ||
            element?.partyType === undefined) &&
          ((user?.loanUserType === "Guarantor" && element?.guarantorAliasKey !== undefined) ||
            (user?.loanUserType === "Borrower" && element?.borrowerAliasKey !== undefined))
        ) {
          if (element?.field === "ssNumber" || element?.field === "eiNumber") {
            obj.encryptionId =
              element?.field === "ssNumber"
                ? resolvePath("customer.ssnEncryptionId", user)
                : resolvePath("customer.einEncryptionId", user); // adjust path if needed
            obj.isEncryptedValueFetched = false; // adjust path if needed
          }
          if (creditBureauFields.includes(element?.field)) {
            obj.creditInfoId = getCreditInfoId(element?.field, userData);
          }
          obj.partyType = user?.customer?.partyType;
          obj.userType = user?.loanUserType;
          obj.labelType = type;
          obj.index = user.index;
          obj.aliasKey =
            user?.loanUserType === "Borrower"
              ? element?.borrowerAliasKey
              : element?.guarantorAliasKey;
          obj.identifier =
            element?.ddIdentifier !== undefined
              ? element?.ddIdentifier
              : element?.borrowerAliasKey;
          obj.label = element?.customLabel
            ? `${type} ${index + 1} ${element?.label} Credit Score`
            : `${type} ${index + 1} ${element?.label}`;
          obj.loanUserMapId = user.loanUserMapId;
          obj.loanUserSequence = user.loanUserSequence;
          obj.partyId = user?.customer?.partyId;
          obj.isPrimary = user.isPrimary;
          obj.comment = defaultComment.updatedThroughTTF;
          obj.fieldFlattenedKey = `data.loans.loanUserMap.${
            user?.index ? Number(user?.index) : 0
          }.${element?.path}`;
          obj.tprInfoPath = `data.loans.loanUserMapUpdated.${
            type === "Entity" ? "entities" : "persons"
          }.${index}.${element?.path}`;
          initializeObj(obj, element, null, editHistory);
          if(element?.hideClearIcon) {
            obj.hideClearIcon = element?.hideClearIcon?.()
          }
          userFields.push(obj);
        }
      });
    });
  }
  return userFields;
};

export const getFormattedValue = (
  value: any,
  type: string,
  callback: Function,
  documentInfo?: any
) => {
  if (type === "billingaddress") {
    return getFormattedAddress(value, false, callback);
  }
  if (documentInfo !== undefined) {
    return prepareForSaveToDB(type, documentInfo, value);
  }
  return value;
};

export const getMissingTagsForTTFReview = (
  tags: string[],
  masterList: any[],
  isDSCR: boolean,
  loanDetails: any
) => {
  let missingTags: any[] = [];
  const minTags = isDSCR
    ? DSCR_REQUIRED_TAGS_FOR_TTFREVIEW
    : BRIDGE_REQUIRED_TAGS_FOR_TTFREVIEW;
  minTags.forEach((tagObj: any) => {
    if (
      !tags?.includes(tagObj.docCode) &&
      (tagObj.shouldBeOmitted ? !tagObj.shouldBeOmitted(loanDetails) : true)
    ) {
      missingTags.push(tagObj.docCode);
    }
  });
  if (missingTags.length) {
    tagGroups.forEach((group: string[]) => {
      if (group.every((val: string) => missingTags.includes(val))) {
        missingTags = missingTags.filter((tag: string) => !group.includes(tag));
        missingTags.push(group);
      } else if (group.some((val: string) => missingTags.includes(val))) {
        missingTags = missingTags.filter((tag: string) => !group.includes(tag));
      }
    });
  }
  const missingTagsDescriptive = missingTags.map((tag: string | string[]) => {
    if (Array.isArray(tag)) {
      return tag.reduce(
        (prevVal: string, currVal: string, index: number) =>
          index === 0
            ? getTagDataFromTagCode(currVal, masterList)
            : `${prevVal} / ${getTagDataFromTagCode(currVal, masterList)}`,
        ""
      );
    }
    return getTagDataFromTagCode(tag, masterList);
  });
  return missingTagsDescriptive;
};

export const getTagDataFromTagCode = (code: string, masterList: any[]) =>
  masterList.find((tag: any) => tag?.code === code)?.name;

export const updateHistoryOnSubmit = (
  loanFields: any,
  userFields: any,
  propertyFields: any,
  editHistory: any,
  dispatch: any
) => {
  const loanFieldsPayload: any = JSON.parse(JSON.stringify(loanFields));
  const userFieldsPayload: any = JSON.parse(JSON.stringify(userFields));
  const propertyFieldsPayload: any = JSON.parse(JSON.stringify(propertyFields));
  loanFieldsPayload.forEach((field: any) => {
    field.auditHistory = editHistory?.[getFieldName(field)];
  });
  userFieldsPayload.forEach((field: any) => {
    field.auditHistory = editHistory?.[getFieldName(field)];
  });
  propertyFieldsPayload.forEach((element: any) => {
    element?.forEach((ele: any) => {
      ele.auditHistory = editHistory?.[getFieldName(ele)];
    });
  });
  // dispatch({
  //   type: UPDATE_TTF_FIELDS,
  //   payload: {
  //     loanFieldsPayload,
  //     userFieldsPayload,
  //     propertyFieldsPayload
  //   }
  // });
  updateTtfFields({
    loanFieldsPayload,
    userFieldsPayload,
    propertyFieldsPayload
  });
};

export const updateLocalReducerValue = (
  documentReviewDispatch: any,
  extractionSource: any[]
) => {
  const activePageNumber = extractionSource?.[0]?.pageNo;
  documentReviewDispatch({
    type: ttfAction.UPDATE_PAGE_OR_HIGHLIGHT_SET,
    payload: {
      value: {
        highlightCoordinates: extractionSource,
        ...((activePageNumber || activePageNumber === 0) && {
          activePageNumber
        })
      },
      tabToUpdate: tabIds.DOCUMENT_REVIEW
    }
  });
};

export const updateTTFDBCallFlag = (
  documentReviewDispatch: any,
  payload: any
) => {
  documentReviewDispatch({
    type: ttfAction.UPDATE_TTF_PARAMS,
    payload: {
      value: payload,
      tabToUpdate: tabIds.DOCUMENT_REVIEW
    }
  });
};

export const clearRadio = (
  dispatch: any,
  loanFields: any,
  userFields: any,
  propertyFields: any
) => {
  const newLoanFields = JSON.parse(JSON.stringify(loanFields));
  const newUserFields = JSON.parse(JSON.stringify(userFields));
  const newPropertyFields = JSON.parse(JSON.stringify(propertyFields));
  newLoanFields.forEach((item: any) => {
    delete item?.radio;
  });
  newUserFields.forEach((item: any) => {
    delete item?.radio;
  });
  newPropertyFields.forEach((property: any) => {
    property.forEach((item: any, propertyIndex: number) => {
      delete item?.radio;
    });
  });
  dispatch(
    updateTtfFields({
      loanFieldsPayload: newLoanFields,
      userFieldsPayload: newUserFields,
      propertyFieldsPayload: newPropertyFields
    })
  );
  // dispatch({
  //   type: UPDATE_TTF_FIELDS,
  //   payload: {
  //     loanFieldsPayload: newLoanFields,
  //     userFieldsPayload: newUserFields,
  //     propertyFieldsPayload: newPropertyFields
  //   }
  // });
};

export const groupByTags = (docList: ObjectType[]) => {
  const newDocList = JSON.parse(JSON.stringify(docList));
  const tagCounts: ObjectType = {};

  newDocList.forEach((obj: ObjectType, index: number) => {
    const code = obj.TagsInternal?.[0]?.tag?.code;
    if (tagCounts[code] === undefined) {
      tagCounts[code] = 1;
      obj.groupType = "start-end";
    } else {
      tagCounts[code]++;

      if (tagCounts[code] === 2) {
        newDocList[index - 1].groupType = "start";
      }
      if (
        index === newDocList.length - 1 ||
        code !== newDocList[index + 1]?.TagsInternal?.[0]?.tag?.code
      ) {
        obj.groupType = "end";
      } else {
        obj.groupType = "between";
      }
    }
  });

  return newDocList;
};

export const highLightMap = (
  key: string,
  index: number,
  documents: ObjectType[]
) => {
  const { length } = documents;
  const map: ObjectType = {
    start: {
      backgroundColor: "#faf1ad61",
      borderTop:
        index === 0 || documents[index - 1]?.groupType === "start-end"
          ? "2px solid #f7b500"
          : "1px solid #f7b500",
      borderLeft: "2px solid #f7b500",
      borderRight: "2px solid #f7b500",
      borderBottom: "none",
      padding: "2px 0"
    },
    between: {
      backgroundColor: "#faf1ad61",
      borderTop: "none",
      borderLeft: "2px solid #f7b500",
      borderRight: "2px solid #f7b500",
      borderBottom: "none",
      padding: "2px 0"
    },
    end: {
      backgroundColor: "#faf1ad61",
      borderTop: "none",
      borderLeft: "2px solid #f7b500",
      borderRight: "2px solid #f7b500",
      borderBottom:
        index === length - 1 || documents[index + 1]?.groupType === "start-end"
          ? "2px solid #f7b500"
          : "1px solid #f7b500",
      padding: "2px 0"
    },
    "start-end": {
      // backgroundColor: "#faf1ad61",
      // borderTop: index === 0 ? "2px solid #f7b500" : "1px solid #f7b500",
      // borderLeft: "2px solid #f7b500",
      // borderRight: "2px solid #f7b500",
      // borderBottom: index === length - 1 ? "2px solid #f7b500" : "1px solid #f7b500",
      padding: "2px 0"
    }
  };
  return map[key];
};

function isAllKeysNullForTheSet(obj: ObjectType, excludeKeys: string[] = []) {
  if (!obj || typeof obj !== "object") return true; // Handle null or non-object cases
  return Object.keys(obj)
    .filter((key) => !excludeKeys.includes(key)) // Exclude specified keys
    .every((key) => [null, ""].includes(obj[key]));
}

export function isDataCorrupt(saveObj: ObjectType) {
  const loans = saveObj?.documentInfo?.loans;

  if (!loans) return false;

  const conditions = [
    isAllKeysNullForTheSet(loans?.loanEconomics),
    isAllKeysNullForTheSet(loans?.loanInfo),
    isAllKeysNullForTheSet(loans?.loanDetailId?.loanSummaryId),
    isAllKeysNullForTheSet(loans?.loanFees),
    !Array.isArray(loans?.loanUserMap) ||
      loans.loanUserMap.every((user: ObjectType) => {
        const excludeKeys = [
          "customer",
          "loanUserMapId",
          "isPrimary",
          "loanUserSequence",
          "loanUserType",
          "partyId"
        ];
        return (
          isAllKeysNullForTheSet(user.customer, [
            "addressList",
            "contactList",
            "partyType",
            "creditInformation"
          ]) &&
          isAllKeysNullForTheSet(user.customer?.addressList?.[0]) &&
          isAllKeysNullForTheSet(user.customer?.contactList?.[0]) &&
          isAllKeysNullForTheSet(user, excludeKeys)
        );
      })
  ];
  return conditions.every((condition) => condition === true);
}

export function transformValuations(valuations: any[] = []) {
  return valuations.map(({ payload, valuationId }) => ({
    appraisalType: payload?.appraisalType || null,
    appraisalAsIsValue: formatCurrencyValue(payload?.appraisalAsIsValue),
    appraisalArvValue: formatCurrencyValue(payload?.appraisalArvValue),
    appraisalDate: payload?.appraisalDate || null,
    op: "replace",
    valuationId
  }));
}

function convertToISODateIfNeeded(dateStr: string): string | null {
  if (!dateStr) return null;

  const mmddyyyyRegex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/\d{4}$/;
  if (mmddyyyyRegex.test(dateStr)) {
    const [month, day, year] = dateStr.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  return dateStr.split("T")[0].split(" ")[0];
}

export function postLoanTransformValuations(valuations: any[] = []) {
  // TODO: remove this function and use transformValuations instead
  return valuations.map((valuation) => {
    const payload = valuation?.payload || {};
    const appraisalAsIsValue = payload?.appraisalAsIsValue;
    const appraisalArvValue = payload?.appraisalArvValue;
    const rawAppraisalDate = payload?.appraisalDate;

    return {
      appraisalType: payload?.appraisalType || null,
      appraisalAsIsValue:
        typeof appraisalAsIsValue === "number"
          ? appraisalAsIsValue
          : formatCurrencyValue(appraisalAsIsValue),
      appraisalArvValue:
        typeof appraisalArvValue === "number"
          ? appraisalArvValue
          : formatCurrencyValue(appraisalArvValue),
      appraisalDate: convertToISODateIfNeeded(rawAppraisalDate),
      op: payload?.op === "add" ? "add" : "replace",
      valuationOrder: valuation?.payload?.valuationOrder
        ? valuation?.payload?.valuationOrder
        : payload?.appraisalType === "Desk Review" ? 100 : 1
    };
  });
}

export const validatePropertyLocationFields = (
  updatedFieldSet: ObjectType[],
  indexInList: number
) => {
  if (
    ["city", "state", "postalCode"].includes(updatedFieldSet[indexInList].field)
  ) {
    const indexOfPropAddressInList = updatedFieldSet.findIndex(
      (item: any) => item.field === "addressLine1"
    );

    if (
      updatedFieldSet[indexInList].loanInfo !==
        updatedFieldSet[indexInList].documentInfo ||
      updatedFieldSet[indexOfPropAddressInList]?.loanInfo !==
        updatedFieldSet[indexOfPropAddressInList]?.documentInfo
    ) {
      updatedFieldSet[indexOfPropAddressInList].locationValidationStatus =
        "OVERRIDDEN";
    }
  }
};

function isDefinedNonEmpty(val: any) {
  return val !== undefined && val !== null && val !== "";
}

export const setRealtimeFields = (
  updatedFieldSet: ObjectType[],
  indexInList: number,
  loanType: string,
  loanFields: ObjectType[],
  updatedUserFieldSet: ObjectType[],
  recalculateData: any = null,
  fieldChangeMappingState: any = {}
) => {
  const originationDateField: any = loanFields?.filter(
    (field) => field.field === "originationDate"
  );
  const fcbkDataFields: any = updatedUserFieldSet?.filter(
    (field) =>
      field.field === "lastFcDate" ||
      field.field === "lastDelinquencyDate" ||
      field.field === "lastBkDate" ||
      field.field === "lastDilDate" ||
      field.field === "lastSsDate"
  );
  const updatedField: any = updatedFieldSet[indexInList];
  const isDSCRLoan = loanType.includes("DSCR");

  if (updatedField.field === "discountPointAmount") {
    const loanAmount: any = getLoanAmount();
    const discountAmountRaw = isDefinedNonEmpty(updatedField.documentInfo)
      ? updatedField.documentInfo
      : updatedField.loanInfo;
    const discountAmount: any = getNumericValue(discountAmountRaw);
    if (
      !isValidFiniteNumber(discountAmount) ||
      !isValidFiniteNumber(loanAmount)
    ) {
      updateField("discountPointPercentage", "", "percentage");
      return;
    }
    const finalVal = loanAmount
      ? parseFloat(((discountAmount / loanAmount) * 100).toFixed(4))
      : "";
    updateField("discountPointPercentage", finalVal, "percentage");
  } else if (updatedField.field === "originationFeeHUD") {
    const loanAmount: any = getLoanAmount();
    const originationAmountRaw = isDefinedNonEmpty(updatedField.documentInfo)
      ? updatedField.documentInfo
      : updatedField.loanInfo;
    const originationAmount: any = getNumericValue(originationAmountRaw);
    if (
      !isValidFiniteNumber(originationAmount) ||
      !isValidFiniteNumber(loanAmount)
    ) {
      updateField("originationPointPercentage", "", "percentage");
      return;
    }
    const finalVal: any = loanAmount
      ? parseFloat(((originationAmount / loanAmount) * 100).toFixed(4))
      : "";
    updateField("originationPointPercentage", finalVal, "percentage");
  } else if (
    updatedField.field === "originalMaximumLoanAmount" ||
    (updatedField.field === "originalLoanAmount" && isDSCRLoan)
  ) {
    const loanAmount: any = getLoanAmount();
    // Loan amount itself changed → recalculate both
    const discountPointAmountIndex = updatedFieldSet.findIndex(
      (item) => item.field === "discountPointAmount"
    );
    const discountAmountRaw = isDefinedNonEmpty(
      updatedFieldSet[discountPointAmountIndex]?.documentInfo
    )
      ? updatedFieldSet[discountPointAmountIndex]?.documentInfo
      : updatedFieldSet[discountPointAmountIndex]?.loanInfo;
    const discountAmount: any = getNumericValue(discountAmountRaw);
    if (
      !isValidFiniteNumber(discountAmount) ||
      !isValidFiniteNumber(loanAmount)
    ) {
      updateField("discountPointPercentage", "", "percentage");
      return;
    }
    let finalVal: any = loanAmount
      ? parseFloat(((discountAmount / loanAmount) * 100).toFixed(4))
      : "";
    updateField("discountPointPercentage", finalVal, "percentage");

    const originationFeeAmountIndex = updatedFieldSet.findIndex(
      (item) => item.field === "originationFeeHUD"
    );
    const originationAmountRaw = isDefinedNonEmpty(
      updatedFieldSet[originationFeeAmountIndex].documentInfo
    )
      ? updatedFieldSet[originationFeeAmountIndex].documentInfo
      : updatedFieldSet[originationFeeAmountIndex].loanInfo;
    const originationAmount: any = getNumericValue(originationAmountRaw);
    if (!isValidFiniteNumber(originationAmount)) {
      updateField("discountPointPercentage", "", "percentage");
      return;
    }
    finalVal = loanAmount
      ? parseFloat(((originationAmount / loanAmount) * 100).toFixed(4))
      : "";
    updateField("originationPointPercentage", finalVal, "percentage");
  } else if (
    updatedField.field === "originationDate" ||
    updatedField.field === "lastFcDate" ||
    updatedField.field === "lastDelinquencyDate" ||
    updatedField.field === "lastBkDate" ||
    updatedField.field === "lastDilDate" ||
    updatedField.field === "lastSsDate"
  ) {
    if (updatedField.field === "originationDate") {
      const updatedOriginationDate = isDefinedNonEmpty(
        updatedField.documentInfo
      )
        ? updatedField.documentInfo
        : updatedField.loanInfo;

      if (updatedOriginationDate) {
        fcbkDataFields.forEach((field: any) => {
          const individualFieldValue = isDefinedNonEmpty(field.documentInfo)
            ? field.documentInfo
            : field.loanInfo;
          if (individualFieldValue) {
            const finalVal = calculateMonthDifference(
              new Date(individualFieldValue),
              new Date(updatedOriginationDate)
            );
            const fieldValue: any = getMonthsKey(field.field);
            updateUserField(fieldValue, finalVal, "");
          }
        });
      }
    } else {
      const originationDate = isDefinedNonEmpty(
        originationDateField[0]?.documentInfo
      )
        ? originationDateField[0]?.documentInfo
        : originationDateField[0]?.loanInfo;
      const updatedFieldValue = isDefinedNonEmpty(updatedField.documentInfo)
        ? updatedField.documentInfo
        : updatedField.loanInfo;
      if (updatedFieldValue && originationDate) {
        const finalVal = calculateMonthDifference(
          new Date(updatedFieldValue),
          new Date(originationDate)
        );

        const field: any = getMonthsKey(updatedField.field);
        updateField(field, finalVal, "");
      }
    }
  }

  if (
    recalculateData &&
    (updatedField.field === "interestRateAsOfCutOffDate" ||
      updatedField.field === "originalMaximumLoanAmount" ||
      updatedField.field === "interestOnlyPeriod")
  ) {
    recalculateData(updatedFieldSet);
  }

  fieldChangeMappingState = computeUpdatedState(
    updatedFieldSet,
    indexInList,
    fieldChangeMappingState
  );

  function updateField(fieldName: string, finalVal: any, type: string) {
    const targetIndex = updatedFieldSet.findIndex(
      (item) => item.field === fieldName
    );
    if (targetIndex === -1) return;
    const documentInfoValue = typeCast(finalVal, type);
    updatedFieldSet[targetIndex].documentInfo = documentInfoValue;

    updatedFieldSet[targetIndex].documentInfoDB = prepareForSaveToDB(
      updatedFieldSet[targetIndex].type,
      documentInfoValue,
      finalVal ?? 0 // if no valid calc, pass 0 or handle inside prepareForSaveToDB
    );
  }
  function updateUserField(fieldName: string, finalVal: any, type: string) {
    if (!updatedUserFieldSet) return;

    const targetIndex = updatedUserFieldSet.findIndex(
      (item) => item.field === fieldName
    );
    if (targetIndex === -1) return;
    const documentInfoValue = typeCast(finalVal, type);
    updatedUserFieldSet[targetIndex].documentInfo = documentInfoValue;
    updatedUserFieldSet[targetIndex].documentInfoDB = prepareForSaveToDB(
      updatedUserFieldSet[targetIndex].type,
      documentInfoValue,
      finalVal ?? 0 // if no valid calc, pass 0 or handle inside prepareForSaveToDB
    );
  }

  function getLoanAmount() {
    const loanAmountField = isDSCRLoan
      ? "originalLoanAmount"
      : "originalMaximumLoanAmount";
    const loanAmountIndex = updatedFieldSet.findIndex(
      (item) => item.field === loanAmountField
    );

    if (loanAmountIndex === -1) return ""; // safety check if loan amount field not found

    const loanAmountRaw =
      updatedFieldSet[loanAmountIndex].documentInfo ??
      updatedFieldSet[loanAmountIndex].loanInfo;
    const loanAmount = getNumericValue(loanAmountRaw);
    return loanAmount;
  }
};
function getMonthsKey(dateKey: string) {
  return dateKeys.find((d) => d.dateKey === dateKey)?.monthsKey;
}
function getDateKey(monthsKey: string) {
  return dateKeys.find((d) => d.monthsKey === monthsKey)?.dateKey;
}
function calculateLastFcSsDilBkMonths(field: any, user: any, loanDetails: any) {
  // get originationDate
  const documentInfoOriginationDate = resolvePath(
    "loanInfo.originationDate",
    user
  );
  const currentInfoOriginationDate = loanDetails?.loanInfo?.originationDate;
  const originationDateToBeTaken =
    documentInfoOriginationDate || currentInfoOriginationDate;
  // get fc/bk date fields

  const path = `customer.${getDateKey(field.field)}`;
  const documentInfoCreditEventFieldsDate = resolvePath(path, user);
  const currentInfoCreditEventFieldsDate = resolvePath(
    path,
    loanDetails?.loanUserMap
  );

  const curentInfoFieldDateToBeTaken =
    documentInfoCreditEventFieldsDate || currentInfoCreditEventFieldsDate;

  if (curentInfoFieldDateToBeTaken && originationDateToBeTaken) {
    const finalVal = calculateMonthDifference(
      new Date(curentInfoFieldDateToBeTaken),
      new Date(originationDateToBeTaken)
    );
    return finalVal;
  }
  return null;
}

function calculateFieldTobeCalculatedOnInitialLoad(
  field: any,
  baseObj: any,
  loanDetails: any
) {
  const fieldName = field.field;
  const loanAmount: any = getLoanAmount(baseObj, loanDetails);
  if (!loanAmount || !isValidFiniteNumber(loanAmount)) return "";

  let amountRaw;

  if (fieldName === "originationPointPercentage") {
    amountRaw = resolveFeeAmount(
      "loanFees.originationFeeHUD",
      baseObj,
      loanDetails
    );
  } else if (fieldName === "discountPointPercentage") {
    amountRaw = resolveFeeAmount(
      "loanDetailId.discountPointAmount",
      baseObj,
      loanDetails
    );
  } else {
    return ""; // Unsupported field
  }

  const amount: any = getNumericValue(amountRaw);
  if (!isValidFiniteNumber(amount) || !isValidFiniteNumber(loanAmount)) {
    return ""; // Invalid amount or loan amount
  }
  const percentage = parseFloat(((amount / loanAmount) * 100).toFixed(4));
  return percentage;

  // Helper to get the loan amount based on loan type
  function getLoanAmount(base: any, details: any) {
    const isDSCRLoan = details?.loanType === "30 Year Loan";
    const path = isDSCRLoan
      ? "loanEconomics.originalLoanAmount"
      : "loanEconomics.originalMaximumLoanAmount";

    const rawAmount = resolvePath(path, base) || resolvePath(path, details);
    return getNumericValue(rawAmount);
  }

  // Helper to resolve fee amount (tries base first, then details)
  function resolveFeeAmount(path: string, base: any, details: any) {
    const value = resolvePath(path, base);
    return isDefinedNonEmpty(value) ? value : resolvePath(path, details);
  }
}

function getNumericValue(value: string | number) {
  if (typeof value === "number" || value === "") return value;
  if (typeof value === "string") {
    return parseFloat(value.replace(/,/g, ""));
  }
  return "";
}

const getCreditInfoId = (fieldName: string, userData: any[]): number | null => {
  for (const user of userData) {
    const creditInfos = user?.customer?.creditInformation || [];
    const matchedInfo = creditInfos.find(
      (info: any) => info.creditFirm === fieldName
    );
    if (matchedInfo) {
      return matchedInfo.creditInfoId;
    }
  }
  return null;
};

const isValidFiniteNumber = (value: any) => {
  const num = Number(value);
  return typeof value !== "boolean" && Number.isFinite(num) && value !== "";
};

export const isFieldUpdated = (field: any): boolean => {
  const { documentInfoDB, originalValue, type } = field;

  if (type === "date") {
    const newOriginalDate = originalValue?.[0]?.editedValue ?? originalValue;
    const originalDate = newOriginalDate
      ? new Date(newOriginalDate)?.toISOString()
      : null;
    const currentDate = documentInfoDB
      ? new Date(documentInfoDB)?.toISOString()
      : null;
    return originalDate !== currentDate;
  }

  if (type === "number") {
    return Number(documentInfoDB) !== Number(originalValue);
  }

  // handle string or dropdown
  return String(documentInfoDB).trim() !== String(originalValue).trim();
};
export const computeUpdatedState = (
  updatedFieldSet: any,
  indexInList: any,
  fieldChangeMappingState: any
) => {
  const field = updatedFieldSet[indexInList];
  const isUpdated = isFieldUpdated(field);

  fieldChangeMappingState[field.field] = isUpdated;
  return fieldChangeMappingState;
};

export const updatePropertiesDataWithResults = (data: any, key: string) => {
  let newData = data?.properties ?? [];
  switch (key) {
    case "ttfInfo":
      newData = data?.properties?.map((item: any) => {
        const propertiesResults =
          data?.results?.propertiesResults?.[item?.loanPropertyId] ?? {};
        return {
          ...item,
          propertiesResults
        };
      });
      break;
    case "diligenceInfo":
      newData = data?.properties?.map((item: any, index: number) => {
        const propertiesResults =
          data?.results?.propertiesResults?.[index] ?? data?.result?.propertiesResults?.[index] ?? {};
        return {
          ...item,
          propertiesResults
        };
      });
      break;
  }
  return newData;
};

export function deepCleanObj(obj: any): any {
  if (Array.isArray(obj)) {
    return obj
      .map(item => deepCleanObj(item))
      .filter(item => !(
        item === null ||
        item === "" ||
        (Array.isArray(item) && item.length === 0) ||
        (typeof item === "object" && Object.keys(item).length === 0)
      ));
  } else if (obj !== null && typeof obj === "object") {
    const cleaned: any = {};
    Object.entries(obj).forEach(([key, value]) => {
      const cleanedValue = deepCleanObj(value);
      if (
        cleanedValue !== null &&
        cleanedValue !== "" &&
        !(Array.isArray(cleanedValue) && cleanedValue.length === 0) &&
        !(typeof cleanedValue === "object" && Object.keys(cleanedValue).length === 0)
      ) {
        cleaned[key] = cleanedValue;
      }
    });
    return cleaned;
  }
  return obj;
}

function transformCreditInformation(creditInfoObj: Record<string, { creditValue: string | number }>) {
  return Object.entries(creditInfoObj)?.map(([bureau, data]) => ({
    creditFirm: bureau,
    creditValue: String(data?.creditValue) // ensure it's a number
  }));
}

function filterLoanDataByUpdatedFields(loanData: any, propertiesData: any, updatedFields: any, loanId: string) {
  const result: any = {};
  const filteredProperties: any = [];

  updatedFields.forEach((fieldObj: any) => {
    const { path, loanUserMapId, loanUserSequence, loanPropertyId } = fieldObj;

    const newPath = path.replace("[loanId]", `${loanId}`);
    // -------------------------
    // CASE 1: loanUserMap updates
    // -------------------------
    if (loanUserMapId || loanUserSequence) {
      const matchedUser = loanData.loanUserMap?.find((u: any) =>
        (loanUserMapId && u.loanUserMapId === loanUserMapId) ||
        (loanUserSequence && u.loanUserSequence === loanUserSequence && fieldObj?.label?.includes(u?.loanUserType))
      );

      if (!matchedUser) return;

      if (!result.loanUserMap) result.loanUserMap = [];

      let target = result.loanUserMap.find((x: any) => x.loanUserMapId === matchedUser.loanUserMapId);

      if (!target) {
        // create new entry with required fields
        target = {
          loanUserMapId: matchedUser.loanUserMapId,
          loanUserSequence: matchedUser.loanUserSequence,
          loanUserType: matchedUser.loanUserType,
          isPrimary: matchedUser.isPrimary,
          partyId: matchedUser.partyId
        };

        result.loanUserMap.push(target);
      }

      // assign updated field
      assignByPath(target, matchedUser, newPath);
      return;
    }

    // -------------------------
    // CASE 2: property level updates
    // -------------------------
    if (loanPropertyId) {
      const matchedProp = propertiesData.find((p: any) => p.loanPropertyId === loanPropertyId);
      if (!matchedProp) return;

      let targetProp = filteredProperties.find((p: any) => p.loanPropertyId === loanPropertyId);

      if (!targetProp) {
        targetProp = { loanPropertyId };
        filteredProperties.push(targetProp);
      }

      assignByPath(targetProp, matchedProp, path);
      return;
    }

    // -------------------------
    // CASE 3: regular loanData updates
    // -------------------------
    assignByPath(result, loanData, newPath);
  });

  const returnObj = {
    propertiesData : filteredProperties,
    loanData: { ...result}
  }

  return returnObj;
}

// ------------------------------
// Helper: assign nested path
// Supports array indexes: a.0.b
function assignByPath(target: any, source: any, path: string) {

  // SPECIAL CASE 1: creditInformation.<Firm>.creditValue
// -------------------------------------------
// SPECIAL CASE: customer.creditInformation.<Firm>.creditValue
// Supports:
// 1) Array format: [{ creditFirm: "...", creditValue: ... }]
// 2) Object format: { Experian: { creditValue } }
// -------------------------------------------
if (path.startsWith("customer.creditInformation")) {
  const parts = path.split(".");
  const firm = parts[2]; // Experian / Equifax / TransUnion

  // Safety checks
  if (!source || !source.customer || !source.customer.creditInformation) return;

  const ci = source.customer.creditInformation;
  let matched: any = null;

  // CASE 1 → ARRAY FORMAT
  if (Array.isArray(ci)) {
    matched = ci.find((c: any) => c && c.creditFirm === firm);
  }

  // CASE 2 → OBJECT FORMAT
  else if (typeof ci === "object" && ci !== null) {
    if (firm in ci) {
      matched = { creditFirm: firm, ...ci[firm] }; 
    }
  }

  if (!matched) return;

  // Ensure target structure exists
  if (!target.customer) target.customer = {};
  if (!target.customer.creditInformation) target.customer.creditInformation = [];

  // Push a deep clone (avoid reference sharing)
  target.customer.creditInformation.push(JSON.parse(JSON.stringify(matched)));

  return; // DO NOT continue with normal assignByPath
}


  // SPECIAL CASE 2: valuations.<index>.<field>
  // Keep valuationOrder
  // SPECIAL CASE: valuations.<valuationOrder>.<field>
  if (path.startsWith("valuations.")) {

      const parts = path.split(".");
      const order = Number(parts[1]); // valuationOrder, not index

      if (!target.valuations) target.valuations = [];

      // find existing target valuation block
      let targetVal = target.valuations.find((v: any) => v?.valuationOrder === order);
      if (!targetVal) {
          targetVal = { valuationOrder: order };
          target.valuations.push(targetVal);
      }

      // find valuation from source by valuationOrder
      const matched = source.valuations?.find((v: any) => v?.valuationOrder === order);
      if (!matched) return;

      const fieldKey = parts[2];
      if (fieldKey in matched) {
          targetVal[fieldKey] = matched[fieldKey];
      }

      return; // stop normal handling
  }

  // -------------------------------------------
  // SPECIAL CASE 3: propertyUnit.<index>.<field>
  // Keep propertyUnitId & propertyUnitOrder
  // -------------------------------------------
  if (path.startsWith("propertyUnit.")) {
    const parts = path.split(".");
    const unitIndex = Number(parts[1]); // index of propertyUnit array

    if (!Array.isArray(source.propertyUnit)) return;
    const matchedUnit = source.propertyUnit[unitIndex];
    if (!matchedUnit) return;

    // ensure target.propertyUnit exists
    if (!target.propertyUnit) target.propertyUnit = [];

    let targetUnit = target.propertyUnit.find(
      (u: any) => u.propertyUnitId === matchedUnit.propertyUnitId
    );

    if (!targetUnit) {
      targetUnit = {
        propertyUnitId: matchedUnit.propertyUnitId,
        propertyUnitOrder: matchedUnit.propertyUnitOrder
      };
      target.propertyUnit.push(targetUnit);
    }

    const fieldKey = parts[2];
    if (fieldKey in matchedUnit) {
      targetUnit[fieldKey] = matchedUnit[fieldKey];
    }

    return; // stop normal handling
  }

  // NORMAL PATH HANDLING
  const parts = path.split(".");
  let srcPtr = source;
  let trgPtr = target;

  for (let i = 0; i < parts.length; i++) {
    const key = parts[i];
    const isIndex = /^\d+$/.test(key);

    if (isIndex) {
      const idx = Number(key);

      if (!Array.isArray(trgPtr)) {
        const parentKey = parts[i - 1];
        const parentObj = i === 1 ? target : resolveParent(target, parts.slice(0, i - 1));
        parentObj[parentKey] = [];
        trgPtr = parentObj[parentKey];
      }

      if (!trgPtr[idx]) trgPtr[idx] = {};

      if (i === parts.length - 1) {
        trgPtr[idx] = srcPtr[idx];
        return;
      }

      srcPtr = srcPtr?.[idx];
      if (!srcPtr) return;

      trgPtr = trgPtr[idx];
      continue;
    }

    if (srcPtr == null || !(key in srcPtr)) return;

    if (i === parts.length - 1) {
      trgPtr[key] = srcPtr[key];
      return;
    }

    if (!trgPtr[key]) trgPtr[key] = {};
    srcPtr = srcPtr[key];
    trgPtr = trgPtr[key];
  }
}

// Helper to resolve parent object
function resolveParent(obj: any, parts: string[]) {
  let ptr = obj;
  for (let p of parts) {
    if (!ptr[p]) ptr[p] = {};
    ptr = ptr[p];
  }
  return ptr;
}

const preparePatchLoanPayloadData = (data: any, loanId: string, loanDetails?: any, page?: string, updatedFields?: any) => {
  const cleanedObj = deepCleanObj(data)
  let loanData = cleanedObj?.loans
  let propertyData = [ ...(cleanedObj?.properties ?? []) ]

  const filteredLoanData = filterLoanDataByUpdatedFields(loanData, propertyData, updatedFields, loanId);
  loanData = { ...filteredLoanData?.loanData }
  propertyData = [...(filteredLoanData?.propertiesData ?? []) ]
  // console.log("preparePatchLoanPayloadData", {data, updatedFields, cleanedObj, loanData, propertyData})
  if(loanData?.loanUserMap?.length) {
    loanData.loanUserMap = loanData?.loanUserMap?.map((user: any, index: any) => {
      // const creditInformation = page == "review" ?  user?.customer?.creditInformation : transformCreditInformation(user?.customer?.creditInformation ?? {})
      const creditInformation = user?.customer?.creditInformation
      const lastBkMonths = user?.customer?.lastBkMonths;
      const lastFcMonths = user?.customer?.lastFcMonths;
      const newUser: any = { ...user }
      if(loanData?.loanInfo?.toorakProduct) {
        if(loanData?.loanInfo?.toorakProduct === "Bridge") {
          newUser.borrowerGUCExperience = null;
          newUser.heavyRehabExperience = null;
        } else if(loanData?.loanInfo?.toorakProduct === "Ground-Up") {
          newUser.experience = null;
          newUser.experienceIn3To10Years = null;
        }
      }
      const returnObj = {
          ...newUser,
          op: "replace",
          customer: {
            ...newUser?.customer,
            partyType: newUser?.customer?.partyType ?? loanDetails?.loanUserMap?.[index]?.customer?.partyType,
            accountType: newUser?.customer?.accountType ?? newUser?.loanUserType === "Borrower" ? "BORROWER" : "person",
            creditInformation,
            lastBkMonths: page === "review" ? lastBkMonths : lastBkMonths ? Number(lastBkMonths) : null,
            lastFcMonths: page === "review" ? lastFcMonths : lastFcMonths ? Number(lastFcMonths) : null,
            lastFcDate: newUser?.customer?.lastFcDate ? newUser?.customer?.lastFcDate?.split("T")[0] : null,
            lastSsDate: newUser?.customer?.lastSsDate ? newUser?.customer?.lastSsDate?.split("T")[0] : null,
            lastDilDate: newUser?.customer?.lastDilDate ? newUser?.customer?.lastDilDate?.split("T")[0] : null,
            lastBkDate: newUser?.customer?.lastBkDate ? newUser?.customer?.lastBkDate?.split("T")[0] : null,
            lastDelinquencyDate: newUser?.customer?.lastDelinquencyDate ? newUser?.customer?.lastDelinquencyDate?.split("T")[0] : null,
          }
        }
      if(!newUser?.customer?.creditInformation) {
        delete returnObj?.customer?.creditInformation
      }
      if(newUser?.ownershipOfEntity) {
        returnObj.ownershipOfEntity = Number(newUser?.ownershipOfEntity)
      }
      if(newUser?.customer?.contactList?.length) {
        returnObj.customer.contactList[0].partyContactId = 1 // Hardcoded value as of now as we are not saving multiple contacts in UI
      }
      if(newUser?.customer?.addressList?.length) {
        const addressLine1 = newUser?.customer?.addressList?.[0]?.addressLine1;
        if (addressLine1) {
        const spliwiseAddress = addressLine1?.split(" ") || [];
          const addressObj: any = {};
          if (addressLine1 !== "") {
            addressObj.addressLine1 = addressLine1;
            addressObj.city = spliwiseAddress[spliwiseAddress?.length - 3] || "";
            addressObj.locationValidationStatus = "NONE";
            addressObj.pincode = spliwiseAddress[spliwiseAddress?.length - 1] || "";
            addressObj.state = spliwiseAddress[spliwiseAddress?.length - 2] || "";
          } else {
            addressObj.addressLine1 = addressLine1;
          }

          returnObj.customer = {
            ...returnObj.customer,
            addressList: [
              {
                ...addressObj,
                partyAddressId: 1 // Hardcoded value as of now as we are not saving multiple address in UI
              }
            ]
          };
        }
        // returnObj.customer.addressList[0].partyAddressId = 1 // Hardcoded value as of now as we are not saving multiple contacts in UI
      }
      return { ...returnObj }
    })
  }
  if(loanData?.loanResults?.loanResult) {
    loanData.loanResult = filterLoanResult(loanData?.loanResults?.loanResult, loanDetails)
  }
  if (loanData?.loanDetailId) {
    const { loanDetailId } = loanData;
    delete loanDetailId?.discountPointPercentage;
    delete loanDetailId?.originationPointPercentage;
    loanData.loanDetailId = { ...loanDetailId }
  }
  const numericFields = [
    "initialPeriodicCap",
    "subsequentPeriodicCap",
    "interestRateAsOfCutOffDate",
    "interestOnlyPeriod",
    "initialRateAdjustmentPeriod",
    "initialPayAdjustmentPeriod",
    "prepaymentPenaltyMonths"
  ];

  numericFields.forEach(key => {
    const val = loanData?.loanEconomics?.[key];
    if (val !== null && val !== undefined) {
      loanData.loanEconomics[key] = Number(val);
    }
  });

  const currencyFields = [
    "updatedTaxEscrowBalance",
    "updatedInsuranceEscrowBalance",
    "grossArmMargin",
    "lifeRateCap",
    "lateChargePercentage",
    "financedInterestReserve",
    "originalLoanAmount",
    "currentLoanBalance",
    "cashOutAmount",
    "borrowerLiquidity",
    "grossAmountDueFromBorrowerHUD",
    "discountPointAmount",
    "originationFeeHUD",
    "brokerFeeHUD",
    "assignmentFeeHUD",
    "perDiemInterestHUD",
    "fplMonthlyPI",
    "fplMonthlyTotalPayment",
  ];

  currencyFields.forEach(key => {
    const val = loanData?.loanEconomics?.[key];
    if (val !== null && val !== undefined) {
      loanData.loanEconomics[key] = cleanCurrency(val);
    }
  });

  // if(loanData?.loanEconomics?.interestRateAsOfCutOffDate) {
  //   loanData.loanEconomics.interestRateAsOfCutOffDate = Number(loanData?.loanEconomics?.interestRateAsOfCutOffDate)
  // }
  // if(loanData?.loanEconomics?.interestOnlyPeriod) {
  //   loanData.loanEconomics.interestOnlyPeriod = Number(loanData?.loanEconomics?.interestOnlyPeriod)
  loanData.loanResultData = loanData?.loanResults?.loanResult?.[`${loanId}`]?? loanData?.loanResults?.loanResult?.[`[loanId]`]  ?? {}
  delete loanData?.loanResults
  const propertiesResults: any = {}
  propertyData = propertyData?.map((prop: any) => {
    const newProp = {...prop}
    propertiesResults[prop?.loanPropertyId] = newProp?.propertiesResults
    delete newProp?.propertiesResults
    delete newProp?.loanPropertyOrder
    if(prop?.valuations?.length) {
      newProp.valuations = filterValuationsWithAppraisalData(prop?.valuations ?? [])
    }
    if(newProp?.propertyinfo?.propertyType === "Single Family Detached") {
      newProp.propertyinfo.propertyType = "SFR"
    }
    return {
      loanId,
      ...newProp
    }
  })
  return {
    loanData,
    propertyData,
    propertiesResults
  }
}

function filterLoanResult(data: Record<string, any>, loanDetails: any) {
  const result: Record<string, any> = {};
  for (const loanId in data) {
    const loan = data[loanId];
    const filtered: any = {};
    const totalOriginationAndDiscountPointsCurrencyInTC = loanDetails?.loanResults?.loanResult?.[loanId]?.loanEconomics?.totalOriginationAndDiscountPointsCurrency
    const totalOriginationAndDiscountPointsCurrency = loan?.loanEconomics?.totalOriginationAndDiscountPointsCurrency
    if (
      totalOriginationAndDiscountPointsCurrency !== undefined &&
      totalOriginationAndDiscountPointsCurrencyInTC !== undefined &&
      totalOriginationAndDiscountPointsCurrencyInTC !== totalOriginationAndDiscountPointsCurrency
    ) {
      filtered.loanEconomics = {
        totalOriginationAndDiscountPointsCurrency:
          totalOriginationAndDiscountPointsCurrency,
      };
    }

    const experienceInTC = loanDetails?.loanResults?.loanResult?.[loanId]?.borrowerInfo?.experience
    const experience = loan?.borrowerInfo?.experience
    if (
      experience !== undefined &&
      experienceInTC !== undefined &&
      experienceInTC !== experience
    ) {
      filtered.borrowerInfo = {
        experience: experience,
      };
    }

    result[loanId] = filtered;
  }

  return result;
}

const prepareAuditCommentsForPatchLoanApi = (auditComments: any, loanId: string) => {
  if (auditComments) {
      let result: { [key: string]: string } = {};
      // Check if auditComments is coming in the array of objects used for audit service and transform
      if (
        Array.isArray(auditComments) &&
        auditComments.every(
          (item) =>
            typeof item === "object" && "comment" in item && "field" in item
        )
      ) {
        auditComments.forEach((item: InputItem) => {
          const key = item?.field?.includes("[loanId]") 
            ? item.field?.replace("[loanId]", `${loanId}`)?.replace("loanResults.","")?.replace("loan.","result.")
            : item.field;
          result[key] = item.comment;
        });
      } else {
        result = auditComments;
      }
      return result;
  }

  return {}
}

function filterValuationsWithAppraisalData(valuations: any) {
  const keysToCheck = [
    "appraisalAsIsValue",
    "appraisalArvValue",
    "appraisalDate",
    "appraisalType"
  ];

  return valuations.filter((v: any) =>
    keysToCheck.some(k => v[k] !== undefined && v[k] !== null && v[k] !== "")
  )?.map((v: any) => {
    let appraisalDate = v?.appraisalDate
    if(appraisalDate){
      const d = new Date(appraisalDate);
      appraisalDate = d.toISOString().split("T")[0];
    }
    const obj: any = { 
      appraisalAsIsValue: v?.appraisalAsIsValue ? cleanCurrency(v?.appraisalAsIsValue) : null,
      appraisalArvValue: v?.appraisalArvValue ? cleanCurrency(v?.appraisalArvValue) : null,
      appraisalDate: appraisalDate ?? null,
      appraisalType: v?.appraisalType ? v?.appraisalType : v?.valuationOrder === 100 ? "Desk Review" : null,
      valuationOrder: v?.valuationOrder ?? null,
      op: "replace"
    }
    Object.keys(obj).forEach((key: string) => {
      if (obj[key] === null) {
        delete obj[key];
      }
    })
    return { ...obj }
  });
}

const removeDuplicateFields = (fields: any, sheetFields: any) => {
  const seen = new Set();

  return fields?.filter((obj: any) => {
    if (!sheetFields?.includes(obj?.field)) return false;

    if (seen.has(obj.field)) return false;

    seen.add(obj.field);
    return true;
  }); 
}

const monthlyFields = [
  "monthlyPropertyTaxes",
  "monthlyHazardInsurance",
  "monthlyFloodInsurance",
  "monthlyInsurance"
]

export function allHaveDocumentInfoData(data: any): boolean {
  if (!Array.isArray(data) || data.length === 0) return false;

  return data.every((item) => {
    const hasDocumentInfo =
      item.documentInfo !== null &&
      item.documentInfo !== undefined &&
      item.documentInfo !== "";

    const hasDocumentInfoDB =
      item.documentInfoDB !== null &&
      item.documentInfoDB !== undefined &&
      item.documentInfoDB !== "";

    return hasDocumentInfo && hasDocumentInfoDB;
  });
}

export const showEmptyErrorFieldsErrorPopup = (newValue: string, userFields: any, openSnackbarFn: any): boolean => {
  const isGroundUp = newValue === "Ground-Up";

  const requiredFields = isGroundUp
    ? ["borrowerGUCExperience", "heavyRehabExperience"]
    : ["experience"];

  const expFields = userFields.filter(({ field }: any) =>
    requiredFields.includes(field)
  );

  if (!allHaveDocumentInfoData(expFields)) {
    openSnackbarFn(
      "Please update the experience fields as the Product Type is changed"
    );
    return true;
  }
  return false;
};

// Helper to deep merge loan results for loanInfo and ttfInfo cases
function mergeLoanResults(
  baseResults: any,
  calcResults: any,
  loanId: string
) {
  if (calcResults && baseResults?.loanResult?.[loanId]) {
    return {
      ...baseResults,
      loanResult: {
        ...baseResults.loanResult,
        [loanId]: {
          ...baseResults.loanResult[loanId],
          mlsResults: {
            ...baseResults.loanResult[loanId]?.mlsResults,
            ...calcResults?.mlsResults,
          },
        },
      },
    };
  }
  return baseResults;
}

export const markDiscrepancyFromBE = (
  discrepancies: any[],
  loanFields: any[],
  userFields: any[],
  propertyFields: any[][],
  calculatedFields: any[],
  loanId: string
) => {
  const discrepancyPathSet = new Set(
    discrepancies?.map((d: any) => {
      if(d?.fieldflattenedkey?.includes("loanResult")) {
        return d?.fieldflattenedkey?.replace("loanResult", `loanResult.${loanId}`);
      }
      return d?.fieldflattenedkey;
    })
  );
  const markField = (field: any) => {
    if (discrepancyPathSet.has(field.tprInfoPath)) {
      field.isDiscrepancyFromBe = true;
    }
  };
  loanFields?.forEach(markField);
  userFields?.forEach(markField);
  propertyFields?.forEach((propertyGroup: any[]) => propertyGroup?.forEach(markField));
  calculatedFields?.forEach(markField);
};